webpackJsonp([1],{

/***/ 120:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mutations__ = __webpack_require__(570);




var _mutations;









__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* default */].Store({
  state: {
    pageTitle: null,
    menu: [{ icon: 'assignment', iconClass: 'primary white--text', title: 'Procesos', subtitle: 'Listado', route: 'process-list' }, { icon: 'assignment_late', iconClass: 'primary white--text', title: 'Incidencias', subtitle: 'Listado', route: 'incident-list' }, { icon: 'insert_chart', iconClass: 'primary white--text', title: 'Informes', subtitle: 'Descargas', route: 'report-list' }, { icon: 'event_note', iconClass: 'primary white--text', title: 'Pesadas', subtitle: 'Listado', route: 'measurement-list' }, { icon: 'developer_board', iconClass: 'primary white--text', title: 'Dispositivos', subtitle: 'Listado', route: 'device-list' }],
    notify: {
      timeout: 5000,
      message: null,
      mode: null,
      textColor: null,
      backgroundColor: null,
      visible: false,
      position: 'bottom'
    },
    session: {},
    socket: {
      isConnected: false,
      reconnectError: false,
      topics: {}
    },
    processTotalWeight: null
  },
  actions: {
    logIn: function logIn(_ref, data) {
      var state = _ref.state;

      state.session = { token: data.token, profile: data.profile, modules: data.modules };
      localStorage.setItem(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].config.app.sessionName, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(state.session));
      __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push({ name: 'home' });
    },
    logOut: function logOut(_ref2) {
      var state = _ref2.state;

      state.session = {
        token: null,
        profile: {},
        modules: {}
      };
      localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].config.app.sessionName);
      __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push({ name: 'login' });
    },
    unsubscribe: function unsubscribe(_ref3, topic) {
      var state = _ref3.state;

      delete state.socket.topics[topic];
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$socket.sendObj({ topics: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.keys(state.socket.topics) });
    },
    subscribe: function subscribe(_ref4, subscription) {
      var state = _ref4.state;

      if (!subscription.topic) return;

      state.socket.topics[subscription.topic] = {
        message: null,
        onMessage: subscription.onMessage
      };
      if (state.socket.isConnected) {
        __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$socket.sendObj({ topics: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.keys(state.socket.topics) });
      }
    },

    sendMessage: function sendMessage(context, message) {
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$socket.send(message);
    }
  },
  getters: {
    authenticated: function authenticated(state) {
      return state.session && state.session.token;
    },
    profile: function profile(state) {
      return state.session.profile || {};
    },
    token: function token(state) {
      return state.session.token || null;
    },
    navigation: function navigation(state) {
      return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(state.menu, function (x) {
        return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.includes(state.session.modules, x.title);
      });
    }
  },
  mutations: (_mutations = {
    initialiseStore: function initialiseStore(state) {
      var sessionName = __WEBPACK_IMPORTED_MODULE_4_vue__["default"].config.app.sessionName;
      if (localStorage.getItem(sessionName)) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state.session, JSON.parse(localStorage.getItem(sessionName)));
      }
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutations__["b" /* ACTION_SUCCESS */], function (state, message) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state.notify, {
      message: message,
      backgroundColor: null,
      textColor: 'success',
      visible: true
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutations__["a" /* ACTION_ERROR */], function (state, message) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state.notify, {
      message: message,
      backgroundColor: 'error',
      textColor: null,
      visible: true,
      position: 'top'
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutations__["c" /* TO_ROUTE */], function (state, name) {
    if (name === 'logout') {
      this.logout();
    } else {
      __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push({ name: name });
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'SOCKET_ONOPEN', function SOCKET_ONOPEN(state, event) {
    __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$socket = event.currentTarget;
    __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$socket.sendObj({ topics: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.keys(state.socket.topics) });
    state.socket.isConnected = true;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'SOCKET_ONCLOSE', function SOCKET_ONCLOSE(state, event) {
    state.socket.isConnected = false;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'SOCKET_ONERROR', function SOCKET_ONERROR(state, event) {
    console.error(state.socket, event);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'SOCKET_ONMESSAGE', function SOCKET_ONMESSAGE(state, message) {
    __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(state.socket.topics, function (subscription) {
      subscription.message = message;
      subscription.onMessage(message);
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'SOCKET_RECONNECT', function SOCKET_RECONNECT(state, count) {
    console.info('reconnect');
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'SOCKET_RECONNECT_ERROR', function SOCKET_RECONNECT_ERROR(state) {
    state.socket.reconnectError = true;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'setProcessTotalWeight', function setProcessTotalWeight(state, total) {
    state.processTotalWeight = parseFloat(total);
  }), _mutations)
}));

/***/ }),

/***/ 13:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(120);







/* harmony default export */ __webpack_exports__["a"] = ({
  config: function config() {
    return {
      apiURL: __WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.app.API_URL,
      headers: {
        'Authorization': 'Token ' + __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.token
      }
    };
  },
  request: function request(config, endpoint, params) {
    var headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    config.url = '' + this.config().apiURL + endpoint + '/';
    config.params = params;
    config.headers = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_3__index__["a" /* default */].config().headers, this.config().headers);
    config.headers = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(config.headers, headers);
    return __WEBPACK_IMPORTED_MODULE_3__index__["a" /* default */].request(config).then(function (response) {
      return response.data;
    }).catch(function (error) {
      if (!error.response) {
        __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('error', 'Se perdió la conexión con el servidor.');
      } else if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.includes([500, 404], error.response.status)) {
        __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('error', 'Error inesperado.');
      } else if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.includes([401], error.response.status)) {
        __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('logOut');
      } else if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.includes([403], error.response.status)) {
        __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('error', 'Acceso denegado.');
        __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('toRoute', 'home');
      } else {
        throw error;
      }
    });
  },
  getURL: function getURL(url) {
    var config = {
      method: 'get',
      url: url,
      headers: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_3__index__["a" /* default */].config().headers, this.config().headers)
    };
    return __WEBPACK_IMPORTED_MODULE_3__index__["a" /* default */].request(config).then(function (response) {
      return response.data;
    });
  },
  login: function login(user, password) {
    var config = {
      method: 'post',
      url: this.config().apiURL + 'token/',
      data: { 'username': user, 'password': password }
    };

    return __WEBPACK_IMPORTED_MODULE_3__index__["a" /* default */].request(config);
  },


  // Incidents
  createIncident: function createIncident(data) {
    return this.request({ method: 'post', data: data }, 'incidents');
  },
  getIncidents: function getIncidents(params) {
    return this.request({ method: 'get' }, 'incidents', params);
  },
  getIncident: function getIncident(id) {
    return this.request({ method: 'get' }, 'incidents/' + id);
  },
  editIncident: function editIncident(id, data) {
    var headers = {};

    if ('attachment' in data) {
      headers = { 'Content-Type': 'multipart/form-data' };
    }

    return this.request({ method: 'patch', data: data }, 'incidents/' + id, null, headers);
  },
  getIncidentStatuses: function getIncidentStatuses() {
    return this.request({ method: 'get' }, 'incident-statuses');
  },


  // Processes
  createProcess: function createProcess(data) {
    return this.request({ method: 'post', data: data }, 'processes');
  },
  getProcesses: function getProcesses(params) {
    return this.request({ method: 'get' }, 'processes', params);
  },
  getProcess: function getProcess(id) {
    return this.request({ method: 'get' }, 'processes/' + id);
  },
  editProcess: function editProcess(id, data) {
    return this.request({ method: 'patch', data: data }, 'processes/' + id);
  },
  getProcessStatuses: function getProcessStatuses() {
    return this.request({ method: 'get' }, 'process-statuses');
  },


  // Weighings
  editWeighing: function editWeighing(id, data) {
    return this.request({ method: 'patch', data: data }, 'weighings/' + id);
  },


  // Measurements
  getMeasurements: function getMeasurements(params) {
    return this.request({ method: 'get' }, 'measurements', params);
  },
  getMeasurement: function getMeasurement(id) {
    return this.request({ method: 'get' }, 'measurements/' + id);
  },
  editMeasurement: function editMeasurement(id, data) {
    return this.request({ method: 'patch', data: data }, 'measurements/' + id);
  },


  // Masters
  getRawMaterials: function getRawMaterials() {
    var queryParams = { is_raw_material: true };
    return this.request({ method: 'get' }, 'materials', queryParams);
  },
  getProcessTypeRawMaterials: function getProcessTypeRawMaterials(processTypeId) {
    var queryParams = { process_type: processTypeId };
    return this.request({ method: 'get' }, 'materials', queryParams);
  },
  getProcessTypes: function getProcessTypes() {
    return this.request({ method: 'get' }, 'process-types');
  },
  getTags: function getTags() {
    return this.request({ method: 'get' }, 'tags');
  },
  getMachines: function getMachines() {
    return this.request({ method: 'get' }, 'machines');
  },
  getSeverities: function getSeverities() {
    return this.request({ method: 'get' }, 'severities');
  },
  getDevices: function getDevices() {
    return this.request({ method: 'get' }, 'devices');
  },
  getDevice: function getDevice(id) {
    return this.request({ method: 'get' }, 'devices/' + id);
  },
  report: function report(name, data) {
    return this.request({ method: 'post', data: data }, 'reports', { report_name: name });
  },


  // Devices
  startDevice: function startDevice(id, data) {
    return this.request({ method: 'post', data: data }, 'devices/' + id + '/start');
  },
  stopDevice: function stopDevice(id) {
    return this.request({ method: 'post' }, 'devices/' + id + '/stop');
  },
  zeroDevice: function zeroDevice(id) {
    return this.request({ method: 'post' }, 'devices/' + id + '/zero');
  },
  getDeviceInfo: function getDeviceInfo(id) {
    return this.request({ method: 'get' }, 'devices/' + id + '/info');
  }
});

/***/ }),

/***/ 131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_urlParamsMixin_vue__ = __webpack_require__(325);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_urlParamsMixin_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 17:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formMixin_vue__ = __webpack_require__(318);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formMixin_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 24:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mutationsMixin_vue__ = __webpack_require__(306);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mutationsMixin_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 291:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Device__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_DeviceList__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Home__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Incident__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_IncidentList__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Login__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_Measurement__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_MeasurementList__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_Error__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_Process__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_ProcessList__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_ReportList__ = __webpack_require__(666);

















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  linkExactActiveClass: 'is-active',
  routes: [{
    path: '/home/',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_Home__["a" /* default */],
    meta: { title: function title(route) {
        return 'Inicio';
      } }
  }, {
    path: '/dispositivos/',
    name: 'device-list',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_DeviceList__["a" /* default */],
    props: true,
    meta: { title: function title(route) {
        return 'Dispositivos';
      } }
  }, {
    path: '/dispositivos/:id',
    name: 'device-detail',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_Device__["a" /* default */],
    props: true,
    meta: { title: function title(route) {
        return 'Dispositivos';
      } }
  }, {
    path: '/pesadas/',
    name: 'measurement-list',
    component: __WEBPACK_IMPORTED_MODULE_10__pages_MeasurementList__["a" /* default */],
    props: true,
    meta: { title: function title(route) {
        return 'Pesadas';
      } }
  }, {
    path: '/pesadas/:id',
    name: 'measurement-detail',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_Measurement__["a" /* default */],
    props: true,
    meta: { title: function title(route) {
        return 'Pesada' + route.params.id;
      } }
  }, {
    path: '/incidencias/',
    name: 'incident-list',
    component: __WEBPACK_IMPORTED_MODULE_7__pages_IncidentList__["a" /* default */],
    props: true,
    meta: { title: function title(route) {
        return 'Incidencias';
      } }
  }, {
    path: '/incidencias/:id',
    name: 'incident-detail',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_Incident__["a" /* default */],
    props: true,
    meta: { title: function title(route) {
        return 'Incidencias';
      } }
  }, {
    path: '/procesos/',
    name: 'process-list',
    component: __WEBPACK_IMPORTED_MODULE_13__pages_ProcessList__["a" /* default */],
    props: true,
    meta: { title: function title(route) {
        return 'Procesos';
      } }
  }, {
    path: '/procesos/:id',
    name: 'process-detail',
    component: __WEBPACK_IMPORTED_MODULE_12__pages_Process__["a" /* default */],
    props: true,
    meta: { title: function title(route) {
        return 'Procesos';
      } }
  }, {
    path: '/informes/',
    name: 'report-list',
    component: __WEBPACK_IMPORTED_MODULE_14__pages_ReportList__["a" /* default */],
    props: true,
    meta: { title: function title(route) {
        return 'Informes';
      } }
  }, {
    path: '/error',
    name: 'error',
    component: __WEBPACK_IMPORTED_MODULE_11__pages_Error__["a" /* default */],
    props: true,
    meta: { title: function title(route) {
        return 'Error de conexión';
      } }
  }, {
    path: '/login',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_8__pages_Login__["a" /* default */],
    meta: { title: function title(route) {
        return 'Login';
      } }
  }, { path: '*', redirect: { name: 'home' } }]
});

router.beforeEach(function (to, from, next) {
  var session = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.app.sessionName));
  if (to['name'] !== 'login' && (!session || !session.token)) {
    return next({ name: 'login' });
  }

  if (to.meta.title) {
    document.title = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.pageTitle = to.meta.title(to);
  }
  return next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 298:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_app__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_mutationsMixin__ = __webpack_require__(24);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Device',
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_mutationsMixin__["a" /* default */]],
  beforeDestroy: function beforeDestroy() {
    this.unsubscribe(this.topic);
  },
  beforeMount: function beforeMount() {
    var _this = this;

    this.loading = true;

    this.topic = 'com/alumisel/sensor/' + this.$route.params.id;

    __WEBPACK_IMPORTED_MODULE_3__api_app__["a" /* default */].getDevice(this.$route.params.id).then(function (response) {
      _this.device = response;
      _this.getInfo();
      _this.$store.state.pageTitle = 'Dispositivos | ' + _this.device.code;
      _this.subscribe({
        topic: _this.topic,
        onMessage: _this.onMessage
      });
    });

    __WEBPACK_IMPORTED_MODULE_3__api_app__["a" /* default */].getRawMaterials().then(function (response) {
      _this.materials = response;
    });
  },
  data: function data() {
    return {
      loading: false,
      material: null,
      materials: [],
      device: {},
      errors: {},
      averageSpeed: null,
      status: null,
      weight: null,
      readings: {},
      topic: null
    };
  },

  computed: {
    active: function active() {
      return this.status === 'active';
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['subscribe', 'unsubscribe']), {
    getInfo: function getInfo() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_3__api_app__["a" /* default */].getDeviceInfo(this.device.id).then(function (response) {
        _this2.loading = false;
        _this2.apply(response);
      }).catch(this.deviceError);
    },
    deviceError: function deviceError() {
      this.loading = false;
      this.error('Error de comunicación con el dispositivo');
    },
    start: function start() {
      if (!this.material) {
        this.errors = { material: ['Este campo es requerido'] };
        return;
      }
      this.errors = {};
      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_3__api_app__["a" /* default */].startDevice(this.device.id, { material: this.material }).catch(this.deviceError);
    },
    stop: function stop() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_3__api_app__["a" /* default */].stopDevice(this.device.id).then(function (response) {
        _this3.getInfo();
      }).catch(this.deviceError);
    },
    zero: function zero() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_3__api_app__["a" /* default */].zeroDevice(this.device.id).then(function (response) {
        _this4.success('TARA aplicada');
      }).catch(this.deviceError);
    },
    onMessage: function onMessage(message) {
      if (this.loading) {
        this.loading = false;
      }
      this.apply(message.data);
    },
    apply: function apply(data) {
      if (!data.measurement) return;
      this.status = data.measurement.status;
      this.averageSpeed = data.measurement.speed;
      this.weight = data.measurement.weight;
      this.readings = data.measurement.readings || {};

      if (this.active) {
        this.material = data.measurement.material;
      }
    }
  }),
  filters: {
    formatWeight: function formatWeight(number) {
      var decimals = 4;
      var digits = 7;
      var units = Math.round(number / 1000 * Math.pow(10, decimals));
      var padded = units.toString().padStart(digits, '0');
      return padded.slice(0, -decimals) + '.' + padded.slice(-decimals);
    },
    formatSpeed: function formatSpeed(number) {
      if (!number) return null;
      return parseFloat(number / 1000).toFixed(4);
    },
    formatReading: function formatReading(number) {
      var minutes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(number / 600);
      var seconds = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(number % 600 / 10);
      var miliseconds = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(number % 600 % 10);
      var padded = seconds.toString().padStart(2, 0);
      return minutes + ':' + padded + '.' + miliseconds;
    }
  }
});

/***/ }),

/***/ 306:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(56);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'storeMixin',
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])(['success', 'error', 'toRoute']))
});

/***/ }),

/***/ 307:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_app__ = __webpack_require__(13);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DeviceList',
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_0__api_app__["a" /* default */].getDevices().then(function (response) {
      _this.devices = response;
    });
  },
  data: function data() {
    return {
      devices: []
    };
  }
});

/***/ }),

/***/ 308:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_mutationsMixin__ = __webpack_require__(24);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['navigation'])),
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_mutationsMixin__["a" /* default */]]
});

/***/ }),

/***/ 309:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_app__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_formMixin__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_mutationsMixin__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_filepond__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_filepond___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_filepond__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_filepond_dist_filepond_min_css__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_filepond_dist_filepond_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_filepond_dist_filepond_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_filepond_plugin_file_validate_type__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_filepond_plugin_file_validate_type___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_filepond_plugin_file_validate_type__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







Object(__WEBPACK_IMPORTED_MODULE_4_vue_filepond__["registerPlugin"])(__WEBPACK_IMPORTED_MODULE_6_filepond_plugin_file_validate_type___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'incidentForm',
  components: { FilePond: __WEBPACK_IMPORTED_MODULE_4_vue_filepond___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_formMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_mutationsMixin__["a" /* default */]],
  mounted: function mounted() {
    var _this = this;

    this.loading = true;

    var p1 = __WEBPACK_IMPORTED_MODULE_1__api_app__["a" /* default */].getIncident(this.$route.params.id).then(function (response) {
      _this.incident = response;
      _this.$store.state.pageTitle = 'Incidencias | ' + _this.incident.code;
    });

    var p2 = __WEBPACK_IMPORTED_MODULE_1__api_app__["a" /* default */].getSeverities().then(function (response) {
      _this.masters.severities = response;
    });

    var p3 = __WEBPACK_IMPORTED_MODULE_1__api_app__["a" /* default */].getIncidentStatuses().then(function (response) {
      _this.masters.statuses = response;
    });

    var p4 = __WEBPACK_IMPORTED_MODULE_1__api_app__["a" /* default */].getMachines().then(function (response) {
      _this.masters.machines = response;
    });

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([p1, p2, p3, p4]).then(function () {
      _this.loading = false;
    });
  },

  computed: {
    created: function created() {
      return this.$options.filters.formatDateTime(this.incident.created);
    },
    modified: function modified() {
      return this.$options.filters.formatDateTime(this.incident.modified);
    },
    submitData: function submitData() {
      return {
        status: this.incident.status,
        description: this.incident.description,
        severity: this.incident.severity,
        operator: this.incident.operator,
        duration: this.incident.duration,
        machine: this.incident.machine
      };
    }
  },
  data: function data() {
    return {
      masters: {
        severities: []
      },
      myFiles: [],
      incident: {},
      descriptionRules: [function (v) {
        return !!v || 'Descripción es obligatoria';
      }],
      server: {
        url: __WEBPACK_IMPORTED_MODULE_1__api_app__["a" /* default */].config().apiURL,
        process: {
          url: './incidents/' + this.$route.params.id + '/',
          method: 'PATCH',
          withCredentials: false,
          headers: __WEBPACK_IMPORTED_MODULE_1__api_app__["a" /* default */].config().headers,
          timeout: 7000
        }
      }
    };
  },

  methods: {
    handleFileProcessed: function handleFileProcessed() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__api_app__["a" /* default */].getIncident(this.$route.params.id).then(function (response) {
        _this2.incident = response;
      });
    },
    onSubmit: function onSubmit() {
      return __WEBPACK_IMPORTED_MODULE_1__api_app__["a" /* default */].editIncident(this.incident.id, this.submitData);
    },
    onSuccess: function onSuccess() {
      this.success('Incidencia actualizada con éxito');
    }
  }
});

/***/ }),

/***/ 318:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DatePicker__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_TimePicker__ = __webpack_require__(633);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'formMixin',
  components: { DatePicker: __WEBPACK_IMPORTED_MODULE_1__components_DatePicker__["a" /* default */], TimePicker: __WEBPACK_IMPORTED_MODULE_2__components_TimePicker__["a" /* default */] },
  data: function data() {
    return {
      fieldErrors: {},
      valid: false,
      loading: false
    };
  },

  computed: {
    nonFieldErrors: function nonFieldErrors() {
      return this.fieldErrors['non_field_errors'];
    },
    hasNonFieldErrors: function hasNonFieldErrors() {
      return this.fieldErrors['non_field_errors'] && this.fieldErrors['non_field_errors'].length > 0;
    }
  },
  methods: {
    submit: function submit(event) {
      var _this = this;

      if (!this.valid) {
        return;
      }
      this.loading = true;
      this.fieldErrors = {};
      this.onSubmit().then(function (response) {
        _this.loading = false;
        if (_this.onSuccess) {
          _this.onSuccess(response);
        }
      }).catch(function (error) {
        _this.loading = false;
        if (error.response.data) {
          _this.fieldErrors = error.response.data;
          if (_this.onError) {
            _this.onError(error.response);
          }
        } else {
          _this.error('Ha ocurrido un error inesperado');
        }
      });
    },

    debounceSubmit: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.debounce(function () {
      this.submit();
    }, 1000)
  }
});

/***/ }),

/***/ 319:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['date', 'label', 'errors', 'disabled'],
  data: function data() {
    return {
      selectedDate: this.date,
      modal: false
    };
  },

  methods: {
    accept: function accept() {
      this.$emit('update:date', this.selectedDate);
      this.modal = false;
    }
  },
  computed: {
    displayDate: function displayDate() {
      return this.$options.filters.formatDate(this.date);
    }
  },
  watch: {
    date: function date() {
      this.selectedDate = this.date;
    }
  }
});

/***/ }),

/***/ 320:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['time', 'label', 'errors', 'disabled'],
  data: function data() {
    return {
      selectedTime: this.time,
      modal: false
    };
  },

  methods: {
    accept: function accept() {
      this.$emit('update:time', this.selectedTime);
      this.modal = false;
    }
  },
  watch: {
    time: function time() {
      this.selectedTime = this.time;
    }
  }
});

/***/ }),

/***/ 321:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_app__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DataTable__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__partials_IncidentModal__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_formMixin__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_urlParamsMixin__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_mutationsMixin__ = __webpack_require__(24);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'incidentsList',
  components: { DataTable: __WEBPACK_IMPORTED_MODULE_5__components_DataTable__["a" /* default */], IncidentModal: __WEBPACK_IMPORTED_MODULE_6__partials_IncidentModal__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_formMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_urlParamsMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__mixins_mutationsMixin__["a" /* default */]],
  mounted: function mounted() {
    var _this = this;

    this.loading = true;

    var p1 = __WEBPACK_IMPORTED_MODULE_4__api_app__["a" /* default */].getIncidentStatuses().then(function (response) {
      _this.masters.statuses = response;
    });

    var p2 = __WEBPACK_IMPORTED_MODULE_4__api_app__["a" /* default */].getSeverities().then(function (response) {
      _this.masters.severities = response;
    });

    var p3 = __WEBPACK_IMPORTED_MODULE_4__api_app__["a" /* default */].getMachines().then(function (response) {
      _this.masters.machines = response;
    });

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([p1, p2, p3]).then(function () {
      _this.loading = false;
    });
  },
  data: function data() {
    return {
      drawer: false,
      headers: [{
        text: 'Código',
        align: 'left',
        sortable: true,
        value: 'code'
      }, {
        text: 'Descripción',
        align: 'left',
        sortable: true,
        value: 'description'
      }, {
        text: 'Operador',
        align: 'left',
        sortable: true,
        value: 'operator'
      }, {
        text: 'Duracion',
        align: 'left',
        sortable: true,
        value: 'duration'
      }, {
        text: 'Criticidad',
        align: 'left',
        sortable: true,
        value: 'severity'
      }, {
        text: 'Estado',
        align: 'left',
        sortable: true,
        value: 'status'
      }, {
        text: 'Prioridad',
        align: 'left',
        sortable: true,
        value: 'priority'
      }, {
        text: 'Proceso',
        align: 'left',
        sortable: true,
        value: 'process.code'
      }, {
        text: 'Máquina',
        align: 'left',
        sortable: true,
        value: 'machine.name'
      }, {
        text: 'Creado',
        align: 'left',
        sortable: true,
        value: 'created'
      }, {
        text: 'Modificado',
        align: 'left',
        sortable: true,
        value: 'modified'
      }],
      incidents: [],
      requiredRules: [function (v) {
        return !!v || 'Campo obligatorio';
      }],
      masters: { statuses: [] },
      selectedStatus: [],
      selectedSeverity: [],
      filters: ['status', 'severity', 'created__gte', 'created__lte'],
      activeFilters: {
        status: [],
        severity: [] },
      params: {
        status: [],
        severity: [],
        page: null,
        page_size: null },
      pagination: {},
      currentPage: null,
      totalResults: 0,
      created__gte: false,
      created__lte: false
    };
  },

  computed: {
    activeFiltersCount: function activeFiltersCount() {
      var _this2 = this;

      var counter = 0;
      this.filters.forEach(function (element) {
        if (_this2.isFilterActive(element)) {
          counter = counter + 1;
        }
      });
      return counter;
    }
  },
  methods: {
    setURLQueryParams: function setURLQueryParams() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.params, this.activeFilters, this.pagination);
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.params).forEach(function (key) {
        if (!_this3.params[key]) {
          delete _this3.params[key];
        }
      });
      this.$router.replace({ name: this.$route.name, query: this.params });
    },
    toDetailRoute: function toDetailRoute(id) {
      this.$router.push({ name: 'incident-detail', params: { 'id': id } });
    },
    loadProcessTypeMaterials: function loadProcessTypeMaterials() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_4__api_app__["a" /* default */].getProcessTypeRawMaterials(this.activeFilters.process_type).then(function (response) {
        _this4.masters.materials = response;
        _this4.getIncidents();
      });
    },
    processTypeChanged: function processTypeChanged() {
      var _this5 = this;

      this.process.material = null;
      this.loading = true;

      this.loadProcessTypeMaterials(this.process.process_type).then(function () {
        _this5.loading = false;
      });
    },

    getIncidents: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_4__api_app__["a" /* default */].getIncidents(this.params).then(function (response) {
        _this6.incidents = response.results;
        _this6.totalResults = response.count;
      });
    }, 400),
    resetFilters: function resetFilters() {
      this.activeFilters = {
        status: [],
        severity: [],
        created__gte: null,
        created__lte: null
      };
    },
    isFilterActive: function isFilterActive(filterName) {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.activeFilters).indexOf(filterName) === -1) {
        return false;
      }
      if (Array.isArray(this.activeFilters[filterName])) {
        return this.activeFilters[filterName].length > 0;
      }
      return this.activeFilters[filterName];
    },
    getStatusById: function getStatusById(statusId) {
      return this.masters.statuses.find(function (element) {
        return element.id === statusId;
      });
    },
    getSeverityById: function getSeverityById(severityId) {
      return this.masters.severities.find(function (element) {
        return element.id === severityId;
      });
    },
    getSelectedStatus: function getSelectedStatus() {
      return this.selectedStatus.map(function (e) {
        return e.name;
      }).join(',');
    },
    getSelectedSeverity: function getSelectedSeverity() {
      return this.selectedSeverity.map(function (e) {
        return e.name;
      }).join(',');
    },
    updateSelectedStatus: function updateSelectedStatus() {
      this.selectedStatus = [];

      var self = this;

      this.activeFilters.status.map(function (e) {
        self.selectedStatus.push(self.getStatusById(e));
      });
    },
    updateSelectedSeverity: function updateSelectedSeverity() {
      this.selectedSeverity = [];

      var self = this;
      this.activeFilters.severity.map(function (e) {
        self.selectedSeverity.push(self.getSeverityById(e));
      });
    },
    paginationUpdated: function paginationUpdated(pagination) {
      if (this.loading) {
        this.getUrlParams(this.filters, this.activeFilters);
      }
      this.pagination = pagination;
      this.currentPage = this.pagination.page;
      this.setURLQueryParams(this.filters, this.activeFilters);
      this.getIncidents();
    }
  },
  watch: {
    activeFilters: {
      handler: function handler() {
        if (this.loading) {
          return;
        }

        this.updateSelectedStatus();
        this.updateSelectedSeverity();
        this.currentPage = 1;
        this.setURLQueryParams();
        this.getIncidents();
      },

      deep: true
    },
    search: function search(filter) {
      this.setURLQueryParams();
      this.getIncidents();
    }
  }
});

/***/ }),

/***/ 322:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dataTable',
  props: ['items', 'headers', 'loading', 'rowAction', 'search', 'total', 'page', 'hideActions'],
  created: function created() {
    this.getUrlParams();
  },
  data: function data() {
    return {
      pagination: {
        page: 1,
        sortBy: false,
        descending: false
      },
      paginationParams: {
        'page': 'page',
        'page_size': 'rowsPerPage',
        'o': this.parseSortedBy
      },
      loadedByUrl: false
    };
  },

  methods: {
    getUrlParams: function getUrlParams() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.paginationParams).forEach(function (key) {
        if (!_this.$route['query'][key]) {
          return;
        }
        if (typeof _this.paginationParams[key] === 'function') {
          _this.paginationParams[key](_this.$route['query'][key]);
        } else if (!isNaN(parseInt(_this.$route['query'][key]))) {
          _this.pagination[_this.paginationParams[key]] = parseInt(_this.$route['query'][key]);
        } else {
          _this.pagination[_this.paginationParams[key]] = _this.$route['query'][key];
        }
      });
      this.loadedByUrl = true;
    },
    parseSortedBy: function parseSortedBy(orderBy) {
      if (orderBy.charAt(0) === '-') {
        this.pagination.descending = true;
        this.pagination.sortBy = orderBy.substring(1);
      } else {
        this.pagination.descending = false;
        this.pagination.sortBy = orderBy;
      }
    },
    getParsedOrderBy: function getParsedOrderBy() {
      if (this.pagination.descending) {
        return '-' + this.pagination.sortBy;
      } else {
        return this.pagination.sortBy;
      }
    }
  },
  watch: {
    pagination: {
      handler: function handler() {
        this.$emit('paginationUpdated', {
          page: this.pagination.page,
          page_size: this.pagination.rowsPerPage,
          o: this.getParsedOrderBy()
        });
      },

      deep: true
    },
    page: {
      handler: function handler() {
        this.pagination.page = this.page;
      }
    }
  }
});

/***/ }),

/***/ 323:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IncidentModal_vue__ = __webpack_require__(324);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cc0aaa1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IncidentModal_vue__ = __webpack_require__(646);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IncidentModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cc0aaa1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IncidentModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 324:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_app__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_formMixin__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_mutationsMixin__ = __webpack_require__(24);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['callback', 'drawer', 'process', 'masters'],
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_formMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_mutationsMixin__["a" /* default */]],
  data: function data() {
    return {
      dialog: false,
      incident: {
        operator: null,
        severity: null,
        status: null,
        duration: null,
        description: null,
        machine: null
      },
      requiredRules: [function (v) {
        return !!v || 'Campo obligatorio';
      }]
    };
  },

  methods: {
    onSubmit: function onSubmit() {
      if (this.process) {
        this.incident.process = this.process.id;
      }

      return __WEBPACK_IMPORTED_MODULE_0__api_app__["a" /* default */].createIncident(this.incident);
    },
    onSuccess: function onSuccess(response) {
      this.closeDialog();
      if (this.callback) {
        this.callback();
      } else {
        var route = { name: 'incident-detail', params: { 'id': response.id } };
        this.$router.push(route);
      }
      this.success('Incidencia creada con éxito');
    },
    closeDialog: function closeDialog() {
      this.incident = { severity: null, status: null, description: null };
      this.$refs.form.reset();
      this.dialog = false;
    }
  }
});

/***/ }),

/***/ 325:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getUrlParams: function getUrlParams(fields, target) {
      var _this = this;

      fields.forEach(function (element) {
        var value = _this.$route['query'][element];
        if (!value) return;

        if (Array.isArray(target[element]) && !Array.isArray(value)) {
          target[element] = [_this.parseValue(value)];
        } else {
          target[element] = _this.parseValue(value);
        }
      });
    },
    parseValue: function parseValue(value) {
      if (isNaN(parseInt(value)) || value.length !== parseInt(value).toString().length) return value;
      return parseInt(value);
    }
  }
});

/***/ }),

/***/ 326:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_app__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_formMixin__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_mutationsMixin__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(56);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_formMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_mutationsMixin__["a" /* default */]],
  mounted: function mounted() {
    if (this.authenticated) {
      this.$router.push({ name: 'home' });
    }
  },
  data: function data() {
    return {
      drawer: null,
      showLegalInfo: false,
      loading: false,
      username: '',
      password: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(['authenticated'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['logIn']), {
    onSubmit: function onSubmit() {
      return __WEBPACK_IMPORTED_MODULE_1__api_app__["a" /* default */].login(this.username, this.password);
    },
    onSuccess: function onSuccess(response) {
      return this.logIn(response.data);
    },
    onError: function onError() {
      if (this.nonFieldErrors) {
        this.error(this.nonFieldErrors.join(' '));
      }
    }
  }),
  props: {
    source: String
  }
});

/***/ }),

/***/ 327:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_app__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_formMixin__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_mutationsMixin__ = __webpack_require__(24);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Measurement',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_formMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_mutationsMixin__["a" /* default */]],
  mounted: function mounted() {
    var _this = this;

    var p1 = __WEBPACK_IMPORTED_MODULE_1__api_app__["a" /* default */].getMeasurement(this.$route.params.id).then(function (response) {
      _this.measurement = response;
      if (_this.measurement.measurement_type !== 'full') {
        _this.$router.push({ name: 'measurement-list' });
      }
      _this.materialId = _this.measurement.material ? _this.measurement.material.id : '';
      _this.$store.state.pageTitle = 'Pesadas | ' + _this.measurement.code;
    });

    var p2 = __WEBPACK_IMPORTED_MODULE_1__api_app__["a" /* default */].getProcessTypeRawMaterials(3).then(function (response) {
      _this.materials = response;
    });

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([p1, p2]).then(function () {
      _this.loading = false;
    });
  },

  computed: {
    deviceName: function deviceName() {
      return this.measurement.device ? this.measurement.device.name : '';
    },
    submitData: function submitData() {
      return {
        comment: this.measurement.comment
      };
    }
  },
  data: function data() {
    return {
      errors: {},
      loading: false,
      startDate: null,
      startTime: null,
      endDate: null,
      endTime: null,
      materialId: null,
      measurement: {},
      materials: []
    };
  },

  methods: {
    onSubmit: function onSubmit() {
      return __WEBPACK_IMPORTED_MODULE_1__api_app__["a" /* default */].editMeasurement(this.measurement.id, this.submitData);
    },
    onSuccess: function onSuccess() {
      this.success('Pesada actualizada con éxito');
    }
  },
  watch: {
    measurement: function measurement() {
      var startDateTime = this.$options.filters.splitDateTime(this.measurement.start);
      if (startDateTime) {
        this.startDate = startDateTime.date;
        this.startTime = startDateTime.time;
      }
      var endDateTime = this.$options.filters.splitDateTime(this.measurement.end);
      if (endDateTime) {
        this.endDate = endDateTime.date;
        this.endTime = endDateTime.time;
      }
    }
  }
});

/***/ }),

/***/ 328:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_app__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DataTable__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_urlParamsMixin__ = __webpack_require__(131);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MeasurementList',
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_urlParamsMixin__["a" /* default */]],
  components: { DataTable: __WEBPACK_IMPORTED_MODULE_4__components_DataTable__["a" /* default */] },
  mounted: function mounted() {
    this.loading = true;
    this.getMeasurements();
  },
  data: function data() {
    return {
      loading: false,
      headers: [{
        text: 'Código',
        align: 'left',
        sortable: true,
        value: 'code'
      }, {
        text: 'Comienzo',
        align: 'left',
        sortable: true,
        value: 'start'
      }, {
        text: 'Fin',
        align: 'left',
        sortable: true,
        value: 'end'
      }, {
        text: 'Dispositivo',
        align: 'left',
        sortable: true,
        value: 'device'
      }, {
        text: 'Materia Prima',
        align: 'left',
        sortable: true,
        value: 'material'
      }, {
        text: 'Peso total',
        align: 'right',
        sortable: true,
        value: 'weight'
      }, {
        text: 'Velocidad',
        align: 'right',
        sortable: true,
        value: 'speed'
      }],
      date: Date(),
      measurements: [],
      pagination: {},
      activeFilters: {},
      params: {},
      currentPage: null,
      totalResults: 0
    };
  },

  methods: {
    setURLQueryParams: function setURLQueryParams() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.params, this.activeFilters, this.pagination);
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.params).forEach(function (key) {
        if (!_this.params[key]) {
          delete _this.params[key];
        }
      });
      this.$router.replace({ name: this.$route.name, query: this.params });
    },
    paginationUpdated: function paginationUpdated(pagination) {
      this.pagination = pagination;
      this.currentPage = this.pagination.page;
      this.setURLQueryParams();
      this.getMeasurements();
    },
    toDetailRoute: function toDetailRoute(id) {
      this.$router.push({ name: 'measurement-detail', params: { 'id': id } });
    },

    getMeasurements: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function () {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_3__api_app__["a" /* default */].getMeasurements(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.merge(this.params, { measurement_type: 'full' })).then(function (response) {
        _this2.measurements = response.results;
        _this2.totalResults = response.count;
        _this2.loading = false;
      });
    }, 400)
  },
  watch: {
    activeFilters: {
      handler: function handler() {
        if (this.loading) {
          return;
        }

        this.currentPage = 1;
        this.setURLQueryParams();
        this.getMeasurements();
      },

      deep: true
    }
  }
});

/***/ }),

/***/ 329:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Error'
});

/***/ }),

/***/ 330:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_app__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DataTable__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_formMixin__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__partials_IncidentModal__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_mutationsMixin__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__partials_ProcessForm__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__partials_WeighingForm__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__partials_AnalysisForm__ = __webpack_require__(660);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'process',
  components: { DataTable: __WEBPACK_IMPORTED_MODULE_2__components_DataTable__["a" /* default */], IncidentModal: __WEBPACK_IMPORTED_MODULE_4__partials_IncidentModal__["a" /* default */], ProcessForm: __WEBPACK_IMPORTED_MODULE_6__partials_ProcessForm__["a" /* default */], WeighingForm: __WEBPACK_IMPORTED_MODULE_7__partials_WeighingForm__["a" /* default */], AnalysisForm: __WEBPACK_IMPORTED_MODULE_8__partials_AnalysisForm__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_formMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_mutationsMixin__["a" /* default */]],
  created: function created() {
    var _this = this;

    this.loading = true;
    var p1 = __WEBPACK_IMPORTED_MODULE_1__api_app__["a" /* default */].getProcessTypes().then(function (response) {
      _this.masters.processTypes = response;
    });

    var p2 = __WEBPACK_IMPORTED_MODULE_1__api_app__["a" /* default */].getProcessStatuses().then(function (response) {
      _this.masters.statuses = response;
    });

    var p3 = __WEBPACK_IMPORTED_MODULE_1__api_app__["a" /* default */].getTags().then(function (response) {
      _this.masters.tags = response;
    });

    if (this.process.process_type) {
      this.loadProcessTypeMaterials();
    }

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([p1, p2, p3]).then(function () {
      _this.loading = false;
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    this.loadProcess();

    this.loading = true;
    var p1 = __WEBPACK_IMPORTED_MODULE_1__api_app__["a" /* default */].getIncidentStatuses().then(function (response) {
      _this2.mastersIncidents.statuses = response;
    });

    var p2 = __WEBPACK_IMPORTED_MODULE_1__api_app__["a" /* default */].getSeverities().then(function (response) {
      _this2.mastersIncidents.severities = response;
    });

    var p3 = __WEBPACK_IMPORTED_MODULE_1__api_app__["a" /* default */].getMachines().then(function (response) {
      _this2.mastersIncidents.machines = response;
    });

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([p1, p2, p3]).then(function () {
      _this2.loading = false;
    });
  },
  data: function data() {
    return {
      tab: null,
      masters: {},
      mastersIncidents: {},
      process: {},
      hasAnalysis: null,
      headers: [{
        text: 'Código',
        align: 'left',
        sortable: true,
        value: 'code'
      }, {
        text: 'Descripción',
        align: 'left',
        sortable: true,
        value: 'description'
      }, {
        text: 'Operador',
        align: 'left',
        sortable: true,
        value: 'operator'
      }, {
        text: 'Duración',
        align: 'left',
        sortable: true,
        value: 'duration'
      }, {
        text: 'Criticidad',
        align: 'left',
        sortable: true,
        value: 'severity'
      }, {
        text: 'Estado',
        align: 'left',
        sortable: true,
        value: 'status'
      }, {
        text: 'Prioridad',
        align: 'left',
        sortable: true,
        value: 'priority'
      }, {
        text: 'Máquina',
        align: 'left',
        sortable: true,
        value: 'machine'
      }, {
        text: 'Creado',
        align: 'left',
        sortable: true,
        value: 'created'
      }, {
        text: 'Modificado',
        align: 'left',
        sortable: true,
        value: 'modified'
      }]
    };
  },

  methods: {
    loadProcess: function loadProcess() {
      var _this3 = this;

      this.loading = true;
      var p1 = __WEBPACK_IMPORTED_MODULE_1__api_app__["a" /* default */].getProcess(this.$route.params.id).then(function (response) {
        _this3.process = response;
        _this3.hasAnalysis = _this3.process.analysis.length;
        _this3.$refs.processForm.loadProcessTypeMaterials(_this3.process.process_type);
        _this3.$store.state.pageTitle = 'Procesos | ' + _this3.process.code;
      });
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([p1]).then(function () {
        _this3.$store.commit('setProcessTotalWeight', _this3.process.total_weight);
        _this3.loading = false;
      });
    },
    toDetailRoute: function toDetailRoute(id) {
      this.$router.push({ name: 'incident-detail', params: { 'id': id } });
    },
    onSubmit: function onSubmit() {
      var _this4 = this;

      this.loading = true;
      var data = {
        worker_schedule_hours: this.process.worker_schedule_hours || null,
        break_time: this.process.break_time || null,
        start: this.$options.filters.joinDateTime(this.process.startDate, this.process.startTime),
        end: this.$options.filters.joinDateTime(this.process.endDate, this.process.endTime),
        status: this.process.status,
        comments: this.process.comments,
        tags: this.process.tags,
        process_type: this.process.process_type || null,
        material: this.process.material || null
      };
      return __WEBPACK_IMPORTED_MODULE_1__api_app__["a" /* default */].editProcess(this.process.id, data).then(function (response) {
        _this4.process = response;
        _this4.loading = false;
      });
    },
    onSuccess: function onSuccess() {
      this.success('Proceso actualizado con éxito');
    }
  },
  watch: {
    tab: function tab() {
      this.fieldErrors = {};
    }
  }
});

/***/ }),

/***/ 331:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProcessForm_vue__ = __webpack_require__(332);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_034af6b2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProcessForm_vue__ = __webpack_require__(657);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProcessForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_034af6b2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProcessForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 332:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_app__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_formMixin__ = __webpack_require__(17);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'processForm',
  props: ['isValid', 'showCancel', 'errors', 'process', 'title', 'actionName', 'masters'],
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_formMixin__["a" /* default */]],
  data: function data() {
    return {
      startDate: null,
      startTime: null,
      endDate: null,
      endTime: null,
      materials: []
    };
  },

  methods: {
    loadProcessTypeMaterials: function loadProcessTypeMaterials(processType) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0__api_app__["a" /* default */].getProcessTypeRawMaterials(processType).then(function (response) {
        _this.materials = response;
      });
    },
    processTypeChanged: function processTypeChanged() {
      var _this2 = this;

      this.process.material = null;
      this.loading = true;
      this.loadProcessTypeMaterials(this.process.process_type).then(function () {
        _this2.loading = false;
      });
    },
    hasEmptyWeight: function hasEmptyWeight(weighing) {
      return !weighing['weight'] || parseInt(weighing['weight']) === 0;
    }
  },
  computed: {
    processTypeAndMaterialEditable: function processTypeAndMaterialEditable() {
      if (!this.process.weighings) return true;
      return this.process.weighings.every(this.hasEmptyWeight);
    }
  },
  watch: {
    valid: function valid() {
      this.$emit('update:isValid', this.valid);
    },
    process: function process() {
      var startDateTime = this.$options.filters.splitDateTime(this.process.start);
      if (startDateTime) {
        this.startDate = startDateTime.date;
        this.startTime = startDateTime.time;
      }
      var endDateTime = this.$options.filters.splitDateTime(this.process.end);
      if (endDateTime) {
        this.endDate = endDateTime.date;
        this.endTime = endDateTime.time;
      }
    },
    startDate: function startDate() {
      this.process.startDate = this.startDate;
      this.$emit('update:process', this.process);
    },
    startTime: function startTime() {
      this.process.startTime = this.startTime;
      this.$emit('update:process', this.process);
    },
    endDate: function endDate() {
      this.process.endDate = this.endDate;
      this.$emit('update:process', this.process);
    },
    endTime: function endTime() {
      this.process.endTime = this.endTime;
      this.$emit('update:process', this.process);
    }
  }
});

/***/ }),

/***/ 333:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_app__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_formMixin__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_mutationsMixin__ = __webpack_require__(24);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['weighing'],
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_formMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_mutationsMixin__["a" /* default */]],
  data: function data() {
    return {
      delay: 500,
      dirty: false,
      weight: this.weighing.weight,
      valid: true
    };
  },

  methods: {
    setDirty: function setDirty() {
      this.dirty = true;
      this.fieldErrors.weight = [];
    },
    onSubmit: function onSubmit() {
      var _this = this;

      this.fieldErrors = {};
      this.dirty = false;
      return __WEBPACK_IMPORTED_MODULE_0__api_app__["a" /* default */].editWeighing(this.weighing.id, { weight: this.weight || null }).then(function (response) {
        _this.weighing.weight = response.weight;
      });
    },
    onSuccess: function onSuccess() {
      this.success('Pesada actualizada con éxito');
    },
    getPercentage: function getPercentage(weight) {
      if (!weight) {
        return;
      }

      var percentage = (weight / this.$store.state.processTotalWeight * 100).toFixed(2);
      return 'Toneladas (' + percentage + '%)';
    }
  }
});

/***/ }),

/***/ 334:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formMixin__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_mutationsMixin__ = __webpack_require__(24);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['analysisList'],
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_formMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_mutationsMixin__["a" /* default */]],
  data: function data() {
    return {
      list: this.analysisList
    };
  }
});

/***/ }),

/***/ 335:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_app__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DataTable__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_formMixin__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_urlParamsMixin__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_mutationsMixin__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__partials_ProcessForm__ = __webpack_require__(331);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'processList',
  components: { DataTable: __WEBPACK_IMPORTED_MODULE_5__components_DataTable__["a" /* default */], ProcessForm: __WEBPACK_IMPORTED_MODULE_9__partials_ProcessForm__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_formMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_urlParamsMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_mutationsMixin__["a" /* default */]],
  mounted: function mounted() {
    var _this = this;

    this.loading = true;

    var p1 = __WEBPACK_IMPORTED_MODULE_4__api_app__["a" /* default */].getProcessTypes().then(function (response) {
      _this.loadProcessTypeMaterials();
      _this.masters.processTypes = response;
    });

    var p2 = __WEBPACK_IMPORTED_MODULE_4__api_app__["a" /* default */].getProcessStatuses().then(function (response) {
      _this.masters.statuses = response;
    });

    var p3 = __WEBPACK_IMPORTED_MODULE_4__api_app__["a" /* default */].getTags().then(function (response) {
      _this.masters.tags = response;
    });

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([p1, p2, p3]).then(function () {
      _this.loading = false;
    });
  },
  data: function data() {
    return {
      drawer: false,
      dialogs: {},
      headers: [{
        text: 'Código',
        align: 'left',
        sortable: true,
        value: 'code'
      }, {
        text: 'Tipo',
        align: 'left',
        sortable: true,
        value: 'process_type.name'
      }, {
        text: 'Materia Prima',
        align: 'left',
        sortable: true,
        value: 'material.name'
      }, {
        text: 'Estado',
        align: 'left',
        sortable: true,
        value: 'status'
      }, {
        text: 'Comienzo',
        align: 'left',
        sortable: true,
        value: 'start'
      }, {
        text: 'Fin',
        align: 'left',
        sortable: true,
        value: 'end'
      }, {
        text: 'Total tiempo u.',
        align: 'right',
        sortable: true,
        value: 'total_minutes_lost'
      }, {
        text: 'Peso total',
        align: 'right',
        sortable: true,
        value: 'total_weight'
      }, {
        text: 'Analíticas',
        align: 'right',
        sortable: true,
        value: 'analisys'
      }, {
        text: 'Creado',
        align: 'left',
        sortable: true,
        value: 'created'
      }, {
        text: 'Modificado',
        align: 'left',
        sortable: true,
        value: 'modified'
      }, {
        text: 'Etiquetas',
        align: 'left',
        sortable: true,
        value: 'tags'
      }],
      processes: [],
      newProcess: {},
      selectedProcessType: {},
      selectedMaterials: [],
      selectedStatus: [],
      selectedTags: [],
      masters: { processTypes: [], materials: [], statuses: [] },
      filters: ['material', 'process_type', 'status', 'start__gte', 'end__lte', 'has_analysis'],
      activeFilters: {
        status: [],
        material: [],
        tags: [],
        has_analysis: []
      },
      params: {
        status: [],
        material: [],
        page: null,
        page_size: null },
      pagination: {},
      currentPage: null,
      totalResults: 0,
      start__gte: false,
      end__lte: false
    };
  },

  computed: {
    activeFiltersCount: function activeFiltersCount() {
      var _this2 = this;

      var counter = 0;
      this.filters.forEach(function (element) {
        if (_this2.isFilterActive(element)) {
          counter = counter + 1;
        }
      });
      return counter;
    }
  },
  methods: {
    setURLQueryParams: function setURLQueryParams() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.params, this.activeFilters, this.pagination);
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.params).forEach(function (key) {
        if (!_this3.params[key]) {
          delete _this3.params[key];
        }
      });
      this.$router.replace({ name: this.$route.name, query: this.params });
    },
    joinDateTime: function joinDateTime() {
      return this.$options.filters.joinDateTime;
    },
    toDetailRoute: function toDetailRoute(id) {
      this.$router.push({ name: 'process-detail', params: { 'id': id } });
    },
    onSubmit: function onSubmit() {
      var submitData = {
        process_type: this.newProcess.process_type,
        material: this.newProcess.material,
        worker_schedule_hours: this.newProcess.worker_schedule_hours,
        break_time: this.newProcess.break_time,
        start: this.$options.filters.joinDateTime(this.newProcess.startDate, this.newProcess.startTime),
        end: this.$options.filters.joinDateTime(this.newProcess.endDate, this.newProcess.endTime),
        comments: this.newProcess.comments,
        tags: this.newProcess.tags
      };
      return __WEBPACK_IMPORTED_MODULE_4__api_app__["a" /* default */].createProcess(submitData);
    },
    onSuccess: function onSuccess(response) {
      this.$router.push({ name: 'process-detail', params: { 'id': response.id } });
      this.success('Proceso creado con éxito');
    },
    loadProcessTypeMaterials: function loadProcessTypeMaterials() {
      var _this4 = this;

      this.activeFilters.material = [];

      if (!this.activeFilters.process_type) {
        this.masters.materials = [];
        return;
      }

      return __WEBPACK_IMPORTED_MODULE_4__api_app__["a" /* default */].getProcessTypeRawMaterials(this.activeFilters.process_type).then(function (response) {
        _this4.masters.materials = response;
        _this4.selectedProcessType = _this4.getProcessTypeById(_this4.activeFilters.process_type);
      });
    },

    getProcesses: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_4__api_app__["a" /* default */].getProcesses(this.params).then(function (response) {
        _this5.processes = response.results;
        _this5.totalResults = response.count;
      });
    }, 400),
    resetFilters: function resetFilters() {
      this.activeFilters = {
        material: [],
        status: [],
        process_type: null,
        start__gte: null,
        end__lte: null
      };
    },
    isSomeFilterActive: function isSomeFilterActive(filtersNames) {
      var _this6 = this;

      var active = false;
      filtersNames.forEach(function (element) {
        if (_this6.isFilterActive(element)) {
          active = true;
        }
      });
      return active;
    },
    isFilterActive: function isFilterActive(filterName) {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.activeFilters).indexOf(filterName) === -1) {
        return false;
      }
      if (Array.isArray(this.activeFilters[filterName])) {
        return this.activeFilters[filterName].length > 0;
      }
      return this.activeFilters[filterName];
    },
    getProcessTypeById: function getProcessTypeById(processTypeId) {
      return this.masters.processTypes.find(function (element) {
        return element.id === processTypeId;
      });
    },
    getStatusById: function getStatusById(statusId) {
      return this.masters.statuses.find(function (element) {
        return element.id === statusId;
      });
    },
    getMaterialById: function getMaterialById(materialId) {
      return this.masters.materials.find(function (element) {
        return element.id === materialId;
      });
    },
    getTagById: function getTagById(tagId) {
      return this.masters.tags.find(function (element) {
        return element.id === tagId;
      });
    },
    getSelectedMaterials: function getSelectedMaterials() {
      return this.selectedMaterials.map(function (e) {
        return e.name;
      }).join(',');
    },
    getSelectedStatus: function getSelectedStatus() {
      return this.selectedStatus.map(function (e) {
        return e.name;
      }).join(',');
    },
    updateSelectedMaterials: function updateSelectedMaterials() {
      this.selectedMaterials = [];

      var self = this;
      this.activeFilters.material.map(function (e) {
        self.selectedMaterials.push(self.getMaterialById(e));
      });
    },
    updateSelectedStatus: function updateSelectedStatus() {
      this.selectedStatus = [];

      var self = this;
      this.activeFilters.status.map(function (e) {
        self.selectedStatus.push(self.getStatusById(e));
      });
    },
    updateSelectedTags: function updateSelectedTags() {
      this.selectedTags = [];

      var self = this;
      this.activeFilters.tags.map(function (e) {
        self.selectedTags.push(self.getTagById(e));
      });
    },
    paginationUpdated: function paginationUpdated(pagination) {
      if (this.loading) {
        this.getUrlParams(this.filters, this.activeFilters);
      }
      this.pagination = pagination;
      this.currentPage = this.pagination.page;
      this.setURLQueryParams();
      this.getProcesses();
    },
    hasAnalysis: function hasAnalysis(analysis) {
      if (!analysis.length) {
        return 'No';
      }

      return 'Si';
    }
  },
  watch: {
    activeFilters: {
      handler: function handler() {
        if (this.loading) {
          return;
        }

        this.updateSelectedMaterials();
        this.updateSelectedStatus();
        this.updateSelectedTags();
        this.currentPage = 1;
        this.setURLQueryParams();
        this.getProcesses();
      },

      deep: true
    },
    search: function search(filter) {
      this.setURLQueryParams();
      this.getProcesses();
    }
  }
});

/***/ }),

/***/ 336:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_IncidentsReport__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__partials_ProductionReport__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__partials_MeasurementsReport__ = __webpack_require__(671);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { IncidentsReport: __WEBPACK_IMPORTED_MODULE_0__partials_IncidentsReport__["a" /* default */], ProductionReport: __WEBPACK_IMPORTED_MODULE_1__partials_ProductionReport__["a" /* default */], MeasurementsReport: __WEBPACK_IMPORTED_MODULE_2__partials_MeasurementsReport__["a" /* default */] },
  data: function data() {
    return {
      tab: null
    };
  }
});

/***/ }),

/***/ 337:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_app__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_formMixin__ = __webpack_require__(17);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_formMixin__["a" /* default */]],
  data: function data() {
    return {
      tab: null,
      params: {},
      startDate: null,
      startTime: null,
      endDate: null,
      endTime: null
    };
  },

  methods: {
    onSubmit: function onSubmit() {
      return __WEBPACK_IMPORTED_MODULE_0__api_app__["a" /* default */].report('incidencias', this.params);
    },
    onSuccess: function onSuccess(response) {
      window.location.href = response['download_url'];
    }
  }
});

/***/ }),

/***/ 338:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_app__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_formMixin__ = __webpack_require__(17);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_formMixin__["a" /* default */]],
  mounted: function mounted() {
    var _this = this;

    this.loading = true;

    __WEBPACK_IMPORTED_MODULE_0__api_app__["a" /* default */].getProcessTypes().then(function (response) {
      _this.masters.processTypes = response;
    }).then(function () {
      _this.loading = false;
    });
  },
  data: function data() {
    return {
      tab: null,
      masters: {},
      params: {},
      startDate: null,
      startTime: null,
      endDate: null,
      endTime: null
    };
  },

  methods: {
    onSubmit: function onSubmit() {
      return __WEBPACK_IMPORTED_MODULE_0__api_app__["a" /* default */].report('productividad', this.params);
    },
    onSuccess: function onSuccess(response) {
      window.location.href = response['download_url'];
    },
    loadProcessTypeMaterials: function loadProcessTypeMaterials(processType) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0__api_app__["a" /* default */].getProcessTypeRawMaterials(processType).then(function (response) {
        _this2.masters.materials = response;
      });
    },
    processTypeChanged: function processTypeChanged() {
      var _this3 = this;

      this.params.material = null;
      this.loading = true;

      this.loadProcessTypeMaterials(this.params.process_type).then(function () {
        _this3.loading = false;
      });
    }
  }
});

/***/ }),

/***/ 339:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_app__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_formMixin__ = __webpack_require__(17);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_formMixin__["a" /* default */]],
  data: function data() {
    return {
      tab: null,
      params: {},
      startDate: null,
      startTime: null,
      endDate: null,
      endTime: null
    };
  },

  methods: {
    onSubmit: function onSubmit() {
      return __WEBPACK_IMPORTED_MODULE_0__api_app__["a" /* default */].report('pesadas', this.params);
    },
    onSuccess: function onSuccess(response) {
      window.location.href = response['download_url'];
    }
  }
});

/***/ }),

/***/ 340:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_mutationsMixin__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Snackbar__ = __webpack_require__(676);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: { Snackbar: __WEBPACK_IMPORTED_MODULE_4__components_Snackbar__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_mutationsMixin__["a" /* default */]],
  beforeCreate: function beforeCreate() {
    this.$store.commit('initialiseStore');
  },
  data: function data() {
    return {
      drawer: null,
      snackbar: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['logOut'])),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    currentRouteName: function currentRouteName() {
      return this.$route.name;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["e" /* mapState */])({
    pageTitle: function pageTitle(state) {
      return state.pageTitle;
    }
  }), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['authenticated', 'profile', 'navigation']), {
    profileGroups: function profileGroups() {
      if (!this.profile || !this.profile.groups) return '';
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.join(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(this.profile.groups, 'name'), ',');
    }
  })
});

/***/ }),

/***/ 341:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(56);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["e" /* mapState */])({
    options: function options(state) {
      return state.notify;
    }
  })
});

/***/ }),

/***/ 342:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_filepond_polyfill__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_filepond_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_filepond_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_native_websocket__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_native_websocket___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_native_websocket__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugins_vuetify__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_svgicon__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_svgicon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_svgicon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__filters__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__App__ = __webpack_require__(674);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.













__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_svgicon___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.app = Object({"APP_NAME":"Alumisel","NODE_ENV":"production","API_URL":"https://api-cmplanta.alumisel.com/api/","WS_URL":"/ws/"});
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.app.sessionName = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.app.APP_NAME + 'Session';

var makeUrl = function makeUrl(url) {
  // Support relative URLs
  var _url = void 0;
  if (url[0] === '/') {
    // Use wss:// if running on https://
    var scheme = window.location.protocol === 'https:' ? 'wss' : 'ws';
    var baseUrl = scheme + '://' + window.location.host;
    _url = '' + baseUrl + url;
  } else {
    _url = url;
  }
  return _url;
};

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_native_websocket___default.a, makeUrl(__WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.app.WS_URL), {
  store: __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */],
  format: 'json',
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 3000
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_9__App__["a" /* default */] }
});

/***/ }),

/***/ 549:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a, {
  customProperties: true,
  iconfont: 'md',
  theme: {
    primary: '#D11218',
    accent: '#556677'
  }
});

/***/ }),

/***/ 552:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(40);



__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('formatDateTime', function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(String(value)).format('DD/MM/YYYY HH:mm');
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('formatDate', function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(String(value)).format('DD/MM/YYYY');
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('joinDateTime', function (date, time) {
  if (date || time) {
    if (!date) {
      date = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.format('DD/MM/YYYY');
    }
    if (!time) {
      time = '00:00';
    }
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date + ' ' + time).toDate();
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('splitDateTime', function (datetime) {
  if (datetime) {
    return {
      date: __WEBPACK_IMPORTED_MODULE_0_moment___default()(datetime).format('YYYY-MM-DD'),
      time: __WEBPACK_IMPORTED_MODULE_0_moment___default()(datetime).format('HH:mm')
    };
  }
});

/***/ }),

/***/ 553:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 168,
	"./af.js": 168,
	"./ar": 169,
	"./ar-dz": 170,
	"./ar-dz.js": 170,
	"./ar-kw": 171,
	"./ar-kw.js": 171,
	"./ar-ly": 172,
	"./ar-ly.js": 172,
	"./ar-ma": 173,
	"./ar-ma.js": 173,
	"./ar-sa": 174,
	"./ar-sa.js": 174,
	"./ar-tn": 175,
	"./ar-tn.js": 175,
	"./ar.js": 169,
	"./az": 176,
	"./az.js": 176,
	"./be": 177,
	"./be.js": 177,
	"./bg": 178,
	"./bg.js": 178,
	"./bm": 179,
	"./bm.js": 179,
	"./bn": 180,
	"./bn.js": 180,
	"./bo": 181,
	"./bo.js": 181,
	"./br": 182,
	"./br.js": 182,
	"./bs": 183,
	"./bs.js": 183,
	"./ca": 184,
	"./ca.js": 184,
	"./cs": 185,
	"./cs.js": 185,
	"./cv": 186,
	"./cv.js": 186,
	"./cy": 187,
	"./cy.js": 187,
	"./da": 188,
	"./da.js": 188,
	"./de": 189,
	"./de-at": 190,
	"./de-at.js": 190,
	"./de-ch": 191,
	"./de-ch.js": 191,
	"./de.js": 189,
	"./dv": 192,
	"./dv.js": 192,
	"./el": 193,
	"./el.js": 193,
	"./en-au": 194,
	"./en-au.js": 194,
	"./en-ca": 195,
	"./en-ca.js": 195,
	"./en-gb": 196,
	"./en-gb.js": 196,
	"./en-ie": 197,
	"./en-ie.js": 197,
	"./en-il": 198,
	"./en-il.js": 198,
	"./en-nz": 199,
	"./en-nz.js": 199,
	"./eo": 200,
	"./eo.js": 200,
	"./es": 201,
	"./es-do": 202,
	"./es-do.js": 202,
	"./es-us": 203,
	"./es-us.js": 203,
	"./es.js": 201,
	"./et": 204,
	"./et.js": 204,
	"./eu": 205,
	"./eu.js": 205,
	"./fa": 206,
	"./fa.js": 206,
	"./fi": 207,
	"./fi.js": 207,
	"./fo": 208,
	"./fo.js": 208,
	"./fr": 209,
	"./fr-ca": 210,
	"./fr-ca.js": 210,
	"./fr-ch": 211,
	"./fr-ch.js": 211,
	"./fr.js": 209,
	"./fy": 212,
	"./fy.js": 212,
	"./gd": 213,
	"./gd.js": 213,
	"./gl": 214,
	"./gl.js": 214,
	"./gom-latn": 215,
	"./gom-latn.js": 215,
	"./gu": 216,
	"./gu.js": 216,
	"./he": 217,
	"./he.js": 217,
	"./hi": 218,
	"./hi.js": 218,
	"./hr": 219,
	"./hr.js": 219,
	"./hu": 220,
	"./hu.js": 220,
	"./hy-am": 221,
	"./hy-am.js": 221,
	"./id": 222,
	"./id.js": 222,
	"./is": 223,
	"./is.js": 223,
	"./it": 224,
	"./it.js": 224,
	"./ja": 225,
	"./ja.js": 225,
	"./jv": 226,
	"./jv.js": 226,
	"./ka": 227,
	"./ka.js": 227,
	"./kk": 228,
	"./kk.js": 228,
	"./km": 229,
	"./km.js": 229,
	"./kn": 230,
	"./kn.js": 230,
	"./ko": 231,
	"./ko.js": 231,
	"./ky": 232,
	"./ky.js": 232,
	"./lb": 233,
	"./lb.js": 233,
	"./lo": 234,
	"./lo.js": 234,
	"./lt": 235,
	"./lt.js": 235,
	"./lv": 236,
	"./lv.js": 236,
	"./me": 237,
	"./me.js": 237,
	"./mi": 238,
	"./mi.js": 238,
	"./mk": 239,
	"./mk.js": 239,
	"./ml": 240,
	"./ml.js": 240,
	"./mn": 241,
	"./mn.js": 241,
	"./mr": 242,
	"./mr.js": 242,
	"./ms": 243,
	"./ms-my": 244,
	"./ms-my.js": 244,
	"./ms.js": 243,
	"./mt": 245,
	"./mt.js": 245,
	"./my": 246,
	"./my.js": 246,
	"./nb": 247,
	"./nb.js": 247,
	"./ne": 248,
	"./ne.js": 248,
	"./nl": 249,
	"./nl-be": 250,
	"./nl-be.js": 250,
	"./nl.js": 249,
	"./nn": 251,
	"./nn.js": 251,
	"./pa-in": 252,
	"./pa-in.js": 252,
	"./pl": 253,
	"./pl.js": 253,
	"./pt": 254,
	"./pt-br": 255,
	"./pt-br.js": 255,
	"./pt.js": 254,
	"./ro": 256,
	"./ro.js": 256,
	"./ru": 257,
	"./ru.js": 257,
	"./sd": 258,
	"./sd.js": 258,
	"./se": 259,
	"./se.js": 259,
	"./si": 260,
	"./si.js": 260,
	"./sk": 261,
	"./sk.js": 261,
	"./sl": 262,
	"./sl.js": 262,
	"./sq": 263,
	"./sq.js": 263,
	"./sr": 264,
	"./sr-cyrl": 265,
	"./sr-cyrl.js": 265,
	"./sr.js": 264,
	"./ss": 266,
	"./ss.js": 266,
	"./sv": 267,
	"./sv.js": 267,
	"./sw": 268,
	"./sw.js": 268,
	"./ta": 269,
	"./ta.js": 269,
	"./te": 270,
	"./te.js": 270,
	"./tet": 271,
	"./tet.js": 271,
	"./tg": 272,
	"./tg.js": 272,
	"./th": 273,
	"./th.js": 273,
	"./tl-ph": 274,
	"./tl-ph.js": 274,
	"./tlh": 275,
	"./tlh.js": 275,
	"./tr": 276,
	"./tr.js": 276,
	"./tzl": 277,
	"./tzl.js": 277,
	"./tzm": 278,
	"./tzm-latn": 279,
	"./tzm-latn.js": 279,
	"./tzm.js": 278,
	"./ug-cn": 280,
	"./ug-cn.js": 280,
	"./uk": 281,
	"./uk.js": 281,
	"./ur": 282,
	"./ur.js": 282,
	"./uz": 283,
	"./uz-latn": 284,
	"./uz-latn.js": 284,
	"./uz.js": 283,
	"./vi": 285,
	"./vi.js": 285,
	"./x-pseudo": 286,
	"./x-pseudo.js": 286,
	"./yo": 287,
	"./yo.js": 287,
	"./zh-cn": 288,
	"./zh-cn.js": 288,
	"./zh-hk": 289,
	"./zh-hk.js": 289,
	"./zh-tw": 290,
	"./zh-tw.js": 290
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 553;

/***/ }),

/***/ 570:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ACTION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTION_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TO_ROUTE; });
var ACTION_SUCCESS = 'success';
var ACTION_ERROR = 'error';
var TO_ROUTE = 'toRoute';

/***/ }),

/***/ 572:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Device_vue__ = __webpack_require__(298);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55a300c7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Device_vue__ = __webpack_require__(599);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Device_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55a300c7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Device_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 576:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qs__);




/* harmony default export */ __webpack_exports__["a"] = ({
  config: function config() {
    return {
      mode: 'no-cors',
      responseType: 'json',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      'paramsSerializer': function paramsSerializer(params) {
        return __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(params, { arrayFormat: 'repeat' });
      }
    };
  },
  request: function request(config) {
    config = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.config(), config);
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()(config);
  }
});

/***/ }),

/***/ 599:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"elevation":"0"}},[_c('v-card-title',{staticClass:"pt-4 pb-0 accent--text text--lighten-1"},[_c('div',[_c('label',{staticClass:"title"},[_vm._v(_vm._s(_vm.device.name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.device.code))])])]),_vm._v(" "),_c('v-card-text',{staticClass:"mt-0 accent--text"},[_c('v-layout',{attrs:{"wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"shrink":""}},[_c('label',[_vm._v("Peso total")]),_vm._v(" "),_c('p',{staticClass:"display-4"},[_vm._v("\n          "+_vm._s(_vm._f("formatWeight")(_vm.weight || 0))+"\n          "),_c('sub',[_vm._v("t")])])]),_vm._v(" "),_c('v-flex',{attrs:{"shrink":""}},[_c('p',{staticClass:"display-1 pl-5"},[_vm._v("\n          "+_vm._s(_vm._f("formatSpeed")(_vm.averageSpeed || 0))+" "),_c('sub',[_vm._v("toneladas/hora")])])])],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","justify-space-around":"","mt-5":""}},[_c('v-flex',{attrs:{"shrink":""}},[_c('label',[_vm._v("Tiempo inactivo")]),_vm._v(" "),_c('p',{staticClass:"display-2"},[_vm._v(_vm._s(_vm._f("formatReading")(_vm.readings.inactive || 0)))])]),_vm._v(" "),_c('v-flex',{attrs:{"shrink":""}},[_c('label',[_vm._v("Tiempo activo")]),_vm._v(" "),_c('p',{staticClass:"display-2"},[_vm._v(_vm._s(_vm._f("formatReading")(_vm.readings.active || 0)))])]),_vm._v(" "),_c('v-flex',{attrs:{"shrink":""}},[_c('label',[_vm._v("Tiempo error")]),_vm._v(" "),_c('p',{staticClass:"display-2"},[_vm._v(_vm._s(_vm._f("formatReading")(_vm.readings.errors || 0)))])])],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","justify-center":"","mt-5":""}},[_c('v-flex',{attrs:{"sm12":"","md8":"","lg6":""}},[_c('v-select',{attrs:{"flat":"","items":_vm.materials,"label":"Materia Prima","item-value":"code","item-text":"name","required":"","disabled":_vm.loading || _vm.active,"error-messages":_vm.errors.material},model:{value:(_vm.material),callback:function ($$v) {_vm.material=$$v},expression:"material"}})],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-center"},[_c('v-btn',{attrs:{"color":"accent","depressed":"","large":"","disabled":_vm.loading || _vm.active},on:{"click":function($event){_vm.zero()}}},[_vm._v("TARA")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","depressed":"","large":"","disabled":_vm.loading || _vm.active},on:{"click":function($event){_vm.start()}}},[_vm._v("INICIAR")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","depressed":"","large":"","disabled":_vm.loading || !_vm.active},on:{"click":function($event){_vm.stop()}}},[_vm._v("DETENER")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 600:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeviceList_vue__ = __webpack_require__(307);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72928c3c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeviceList_vue__ = __webpack_require__(601);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeviceList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72928c3c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeviceList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 601:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-3",attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.devices),function(device,$index){return _c('v-flex',{key:$index,attrs:{"xs12":"","sm6":"","md4":"","lg3":""}},[_c('v-card',{staticClass:"white--text",attrs:{"elevation":"0","color":"accent","to":{ name: 'device-detail' , params: { id: device.id } }}},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('div',{staticClass:"headline"},[_vm._v(_vm._s(device.name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(device.code))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(device.url))])])])],1)],1)}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 602:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(308);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_378946d2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(603);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_378946d2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 603:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{attrs:{"fluid":"","justify-center":""}},[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('v-flex',{staticClass:"mt-4 has-text-centered",attrs:{"xs10":""}},[_c('img',{attrs:{"src":"/static/img/alumisel-120x32.png"}})])],1)],1),_vm._v(" "),_c('v-container',{attrs:{"grid-list-xl":"","fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.navigation),function(item){return _c('v-flex',{key:item.title,attrs:{"lg4":"","sm6":"","xs12":""}},[_c('router-link',{staticClass:"pointer",attrs:{"to":{name: item.route},"tag":"div"}},[_c('v-card',{attrs:{"elevation":"0"}},[_c('v-card-title',[_c('v-avatar',[_c('v-icon',{class:[item.iconClass]},[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('div',{staticClass:"ml-3"},[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('P',[_vm._v(_vm._s(item.subtitle))])],1)],1)],1)],1)],1)}))],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 604:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Incident_vue__ = __webpack_require__(309);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00b80f20_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Incident_vue__ = __webpack_require__(640);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Incident_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00b80f20_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Incident_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 631:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DatePicker_vue__ = __webpack_require__(319);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_294c77be_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DatePicker_vue__ = __webpack_require__(632);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DatePicker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_294c77be_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DatePicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 632:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{ref:"dialog",attrs:{"persistent":"","lazy":"","full-width":"","width":"290px","date":_vm.selectedDate,"disabled":_vm.disabled},on:{"update:date":function($event){_vm.selectedDate=$event}},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('v-text-field',{attrs:{"slot":"activator","label":_vm.label,"prepend-icon":"event","disabled":_vm.disabled,"error-messages":_vm.errors,"readonly":""},slot:"activator",model:{value:(_vm.displayDate),callback:function ($$v) {_vm.displayDate=$$v},expression:"displayDate"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"scrollable":"","first-day-of-week":1,"locale":"es-es"},model:{value:(_vm.selectedDate),callback:function ($$v) {_vm.selectedDate=$$v},expression:"selectedDate"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"accent"},on:{"click":function($event){_vm.modal = false}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"depressed":"","color":"accent"},on:{"click":function($event){_vm.accept()}}},[_vm._v("Aceptar")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 633:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimePicker_vue__ = __webpack_require__(320);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6669ac41_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimePicker_vue__ = __webpack_require__(634);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimePicker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6669ac41_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimePicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 634:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{ref:"dialog",attrs:{"persistent":"","lazy":"","full-width":"","width":"290px","time":_vm.selectedTime,"disabled":_vm.disabled},on:{"update:time":function($event){_vm.selectedTime=$event}},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('v-text-field',{attrs:{"slot":"activator","label":_vm.label,"prepend-icon":"access_time","error-messages":_vm.errors,"disabled":_vm.disabled,"readonly":""},slot:"activator",model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}}),_vm._v(" "),_c('v-time-picker',{attrs:{"scrollable":""},model:{value:(_vm.selectedTime),callback:function ($$v) {_vm.selectedTime=$$v},expression:"selectedTime"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"accent"},on:{"click":function($event){_vm.modal = false}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"depressed":"","color":"accent"},on:{"click":function($event){_vm.accept()}}},[_vm._v("Aceptar")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 637:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 640:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"elevation":"0"}},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-lg":"","fill-height":""}},[_c('v-form',{ref:"form",attrs:{"enctype":"multipart/form-data","novalidate":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs6":"","sm4":""}},[_c('v-text-field',{attrs:{"label":"Código","disabled":""},model:{value:(_vm.incident.code),callback:function ($$v) {_vm.$set(_vm.incident, "code", $$v)},expression:"incident.code"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm4":""}},[_c('v-text-field',{attrs:{"label":"Creado","disabled":""},model:{value:(_vm.created),callback:function ($$v) {_vm.created=$$v},expression:"created"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm4":""}},[_c('v-text-field',{attrs:{"label":"Modificado","disabled":""},model:{value:(_vm.modified),callback:function ($$v) {_vm.modified=$$v},expression:"modified"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm4":""}},[_c('v-select',{attrs:{"items":_vm.masters.severities,"cache-items":true,"loading":_vm.loading,"label":"Criticidad","item-value":"id","item-text":"name","error-messages":_vm.fieldErrors.severity,"required":""},on:{"change":function($event){_vm.fieldErrors.severity = []}},model:{value:(_vm.incident.severity),callback:function ($$v) {_vm.$set(_vm.incident, "severity", $$v)},expression:"incident.severity"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm4":""}},[_c('v-select',{attrs:{"items":_vm.masters.statuses,"loading":_vm.loading,"cache-items":true,"label":"Estado","item-value":"id","item-text":"name","error-messages":_vm.fieldErrors.status,"required":""},on:{"change":function($event){_vm.fieldErrors.status = []}},model:{value:(_vm.incident.status),callback:function ($$v) {_vm.$set(_vm.incident, "status", $$v)},expression:"incident.status"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm4":""}},[_c('v-text-field',{attrs:{"label":"Prioridad","disabled":""},model:{value:(_vm.incident.priority),callback:function ($$v) {_vm.$set(_vm.incident, "priority", $$v)},expression:"incident.priority"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm4":""}},[_c('v-autocomplete',{attrs:{"items":_vm.masters.machines,"loading":_vm.loading,"cache-items":true,"label":"Máquina","item-value":"id","item-text":"name","error-messages":_vm.fieldErrors.machine},on:{"change":function($event){_vm.fieldErrors.machine = []}},model:{value:(_vm.incident.machine),callback:function ($$v) {_vm.$set(_vm.incident, "machine", $$v)},expression:"incident.machine"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm4":""}},[_c('v-text-field',{attrs:{"label":"Operador","type":"text"},model:{value:(_vm.incident.operator),callback:function ($$v) {_vm.$set(_vm.incident, "operator", $$v)},expression:"incident.operator"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm4":""}},[_c('v-text-field',{attrs:{"label":"Duración","suffix":"minutos","type":"number","error-messages":_vm.fieldErrors.duration},on:{"input":function($event){_vm.fieldErrors.duration = []}},model:{value:(_vm.incident.duration),callback:function ($$v) {_vm.$set(_vm.incident, "duration", $$v)},expression:"incident.duration"}})],1),_vm._v(" "),(_vm.incident.process)?_c('v-flex',{attrs:{"xs6":"","sm4":""},on:{"click":function($event){_vm.$router.push({name: 'process-detail', params: {'id': _vm.incident.process.id}})}}},[_c('v-select',{attrs:{"items":[_vm.incident.process],"label":"Proceso","item-value":"id","item-text":"code","append-icon":"link","disabled":""},model:{value:(_vm.incident.process),callback:function ($$v) {_vm.$set(_vm.incident, "process", $$v)},expression:"incident.process"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"md6":"","xs12":""}},[_c('v-textarea',{staticClass:"textarea",attrs:{"label":"Descripción","rules":_vm.descriptionRules,"required":"","error-messages":_vm.fieldErrors.description,"rows":"9"},on:{"input":function($event){_vm.fieldErrors.description = []}},model:{value:(_vm.incident.description),callback:function ($$v) {_vm.$set(_vm.incident, "description", $$v)},expression:"incident.description"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md6":"","xs12":""}},[(_vm.incident.attachment)?_c('div',[_c('v-img',{attrs:{"src":_vm.incident.attachment,"height":"80px","contain":""}}),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","href":_vm.incident.attachment,"flat":"","block":""}},[_vm._v("\n                Ver imagen a pantalla completa\n              ")])],1):_vm._e(),_vm._v(" "),_c('FilePond',{ref:"pond",attrs:{"name":"attachment","labelIdle":"Subir imagen","labelFileLoading":"Cargando","labelFileProcessing":"Subiendo","labelFileProcessingComplete":"Subido con éxito","labelFileProcessingAborted":"Subida cancelada","labelFileProcessingError":"Error subiendo fichero","labelTapToCancel":"Tocar para cancelar","labelTapToRetry":"Tocar para reintentar","labelTapToUndo":"Tocar para deshacer","labelButtonAbortItemProcessing":"Cancelar","labelButtonRetryItemLoad":"Reintentar","labelButtonProcessItem":"Subir","allowMultiple":"false","acceptedFileTypes":"image/jpeg, image/png","files":_vm.myFiles,"server":_vm.server},on:{"processfile":_vm.handleFileProcessed}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',{staticClass:"pa-3"},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","depressed":"","large":"","disabled":!_vm.valid,"loading":_vm.loading},on:{"click":_vm.submit}},[_vm._v("\n        Guardar\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 641:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IncidentList_vue__ = __webpack_require__(321);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_158d9f96_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IncidentList_vue__ = __webpack_require__(647);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IncidentList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_158d9f96_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IncidentList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 645:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search,"disable-initial-sort":true,"total-items":_vm.total,"pagination":_vm.pagination,"rows-per-page-text":"Por página","rows-per-page-items":[10, 25, 50, {"text": "Todo", "value": -1}],"loading":_vm.loading==true,"hide-actions":_vm.hideActions},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"pageText",fn:function(props){return [_vm._v("\n    "+_vm._s(props.pageStart)+" - "+_vm._s(props.pageStop)+" de "+_vm._s(props.itemsLength)+"\n  ")]}},{key:"items",fn:function(props){return [_c('tr',{on:{"click":function($event){_vm.rowAction(props.item.id)}}},[_vm._t("row",null,{item:props.item})],2)]}}])},[_c('template',{slot:"no-data"},[_c('v-layout',{staticClass:"title my-5 accent--text justify-center",attrs:{"icon":"warning"}},[_c('p',[_vm._v("No hay datos para mostrar")])])],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 646:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(!_vm.drawer),expression:"!drawer"}],staticClass:"elevation-2",attrs:{"slot":"activator","color":"accent","top":"","right":"","fixed":"","fab":""},slot:"activator"},[_c('v-icon',[_vm._v("add")])],1),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Nueva Incidencia")])]),_vm._v(" "),_c('v-card-text',[(_vm.process)?_c('label',[_vm._v(_vm._s(("Proceso " + (_vm.process.id))))]):_vm._e(),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-form',{ref:"form",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-select',{attrs:{"items":_vm.masters.severities,"cache-items":true,"loading":_vm.loading,"rules":_vm.requiredRules,"label":"Criticidad *","item-value":"id","item-text":"name","error-messages":_vm.fieldErrors.severity,"required":""},on:{"change":function($event){_vm.fieldErrors.severity = []}},model:{value:(_vm.incident.severity),callback:function ($$v) {_vm.$set(_vm.incident, "severity", $$v)},expression:"incident.severity"}}),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.masters.statuses,"loading":_vm.loading,"cache-items":true,"rules":_vm.requiredRules,"label":"Estado *","item-value":"id","item-text":"name","error-messages":_vm.fieldErrors.status,"required":""},on:{"change":function($event){_vm.fieldErrors.status = []}},model:{value:(_vm.incident.status),callback:function ($$v) {_vm.$set(_vm.incident, "status", $$v)},expression:"incident.status"}}),_vm._v(" "),_c('v-autocomplete',{attrs:{"items":_vm.masters.machines,"loading":_vm.loading,"cache-items":true,"label":"Máquina","item-value":"id","item-text":"name","error-messages":_vm.fieldErrors.machine},on:{"change":function($event){_vm.fieldErrors.machine = []}},model:{value:(_vm.incident.machine),callback:function ($$v) {_vm.$set(_vm.incident, "machine", $$v)},expression:"incident.machine"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Operador","type":"text"},model:{value:(_vm.incident.operator),callback:function ($$v) {_vm.$set(_vm.incident, "operator", $$v)},expression:"incident.operator"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Duración","suffix":"minutos","type":"number","error-messages":_vm.fieldErrors.duration},on:{"input":function($event){_vm.fieldErrors.duration = []}},model:{value:(_vm.incident.duration),callback:function ($$v) {_vm.$set(_vm.incident, "duration", $$v)},expression:"incident.duration"}}),_vm._v(" "),_c('v-textarea',{attrs:{"rules":_vm.requiredRules,"label":"Descripción *","error-messages":_vm.fieldErrors.description,"required":""},on:{"input":function($event){_vm.fieldErrors.description = []}},model:{value:(_vm.incident.description),callback:function ($$v) {_vm.$set(_vm.incident, "description", $$v)},expression:"incident.description"}})],1)],1)],1)],1),_vm._v(" "),_c('small',[_vm._v("*campos obligatorios")])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"accent"},nativeOn:{"click":function($event){_vm.closeDialog()}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"depressed":"","color":"accent","disabled":!_vm.valid},on:{"click":_vm.submit}},[_vm._v("\n            Crear\n        ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 647:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-navigation-drawer',{staticClass:"filters-nav",attrs:{"absolute":"","temporary":"","disable-route-watcher":"","right":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-list',{staticClass:"filters"},[_c('v-subheader',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('label',[_vm._v("Filtros")])]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs6":""}},[(_vm.activeFiltersCount)?_c('a',{on:{"click":_vm.resetFilters}},[_vm._v("Borrar todo")]):_vm._e()])],1)],1),_vm._v(" "),_c('v-list-group',{staticClass:"active"},[_c('v-list-tile',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-tile-content',[_c('v-list-tile-title',{class:{'': _vm.isFilterActive(['created__gte'])}},[_vm._v("\n              Fecha creación\n            ")]),_vm._v(" "),(_vm.isFilterActive(['created__gte']))?_c('v-list-tile-sub-title',[_vm._v("\n              "+_vm._s(_vm.activeFilters.created__gte)+"\n            ")]):_vm._e()],1)],1),_vm._v(" "),_c('v-menu',{ref:"created__gte",attrs:{"close-on-content-click":false,"nudge-right":5,"full-width":"","offset-y":"","min-width":"290px"},model:{value:(_vm.created__gte),callback:function ($$v) {_vm.created__gte=$$v},expression:"created__gte"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Desde","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.activeFilters.created__gte),callback:function ($$v) {_vm.$set(_vm.activeFilters, "created__gte", $$v)},expression:"activeFilters.created__gte"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"first-day-of-week":1,"locale":"es-es","no-title":"","scrollable":"","flat":""},on:{"input":function($event){_vm.created__gte = false}},model:{value:(_vm.activeFilters.created__gte),callback:function ($$v) {_vm.$set(_vm.activeFilters, "created__gte", $$v)},expression:"activeFilters.created__gte"}})],1),_vm._v(" "),_c('v-menu',{ref:"created__lte",attrs:{"close-on-content-click":false,"nudge-right":5,"full-width":"","offset-y":"","min-width":"290px"},model:{value:(_vm.created__lte),callback:function ($$v) {_vm.created__lte=$$v},expression:"created__lte"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Hasta","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.activeFilters.created__lte),callback:function ($$v) {_vm.$set(_vm.activeFilters, "created__lte", $$v)},expression:"activeFilters.created__lte"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"first-day-of-week":1,"locale":"es-es","no-title":"","scrollable":""},on:{"input":function($event){_vm.created__lte = false}},model:{value:(_vm.activeFilters.created__lte),callback:function ($$v) {_vm.$set(_vm.activeFilters, "created__lte", $$v)},expression:"activeFilters.created__lte"}})],1)],1),_vm._v(" "),_c('v-list-group',{staticClass:"active"},[_c('v-list-tile',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-tile-content',[_c('v-list-tile-title',{class:{'': _vm.isFilterActive('status')}},[_vm._v("\n              Estado\n            ")]),_vm._v(" "),(_vm.isFilterActive('status'))?_c('v-list-tile-sub-title',[_vm._v("\n              "+_vm._s(_vm.getSelectedStatus())+"\n            ")]):_vm._e()],1)],1),_vm._v(" "),_vm._l((_vm.masters.statuses),function(status){return _c('v-list-tile',{key:status.id},[_c('v-list-tile-action',{staticClass:"checkbox-list"},[_c('v-checkbox',{attrs:{"value":status.id,"hide-details":""},model:{value:(_vm.activeFilters.status),callback:function ($$v) {_vm.$set(_vm.activeFilters, "status", $$v)},expression:"activeFilters.status"}})],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v(_vm._s(status.name))])],1)})],2),_vm._v(" "),_c('v-list-group',{staticClass:"active"},[_c('v-list-tile',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-tile-content',[_c('v-list-tile-title',{class:{'': _vm.isFilterActive('severity')}},[_vm._v("\n              Severidad\n            ")]),_vm._v(" "),(_vm.isFilterActive('severity'))?_c('v-list-tile-sub-title',[_vm._v("\n              "+_vm._s(_vm.getSelectedSeverity())+"\n            ")]):_vm._e()],1)],1),_vm._v(" "),_vm._l((_vm.masters.severities),function(severity){return _c('v-list-tile',{key:severity.id},[_c('v-list-tile-action',{staticClass:"checkbox-list"},[_c('v-checkbox',{attrs:{"value":severity.id},model:{value:(_vm.activeFilters.severity),callback:function ($$v) {_vm.$set(_vm.activeFilters, "severity", $$v)},expression:"activeFilters.severity"}})],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v(_vm._s(severity.name))])],1)})],2)],1)],1),_vm._v(" "),_c('v-toolbar',{staticClass:"pa-3",attrs:{"flat":""}},[_c('v-text-field',{attrs:{"label":"Busca por código, descripción, máquina y operador","append-icon":"search"},model:{value:(_vm.activeFilters.search),callback:function ($$v) {_vm.$set(_vm.activeFilters, "search", $$v)},expression:"activeFilters.search"}}),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"accent"},on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}},[_c('v-badge',{attrs:{"color":"primary","value":_vm.activeFiltersCount}},[_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v(_vm._s(_vm.activeFiltersCount))]),_vm._v(" "),_c('span',[_vm._v("Filtros")])])],1)],1),_vm._v(" "),_c('data-table',{attrs:{"total":_vm.totalResults,"items":_vm.incidents,"headers":_vm.headers,"loading":_vm.loading,"row-action":_vm.toDetailRoute,"page":_vm.currentPage},on:{"paginationUpdated":_vm.paginationUpdated},scopedSlots:_vm._u([{key:"row",fn:function(row){return [_c('td',[_vm._v(_vm._s(row.item.code))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.item.description))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.item.operator))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v("\n        "+_vm._s(row.item.duration)+"\n        "),(row.item.duration)?_c('span',[_vm._v(" m.")]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.item.severity_display))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.item.status_display))]),_vm._v(" "),_c('td',[_c('v-chip',{attrs:{"color":row.item.priority_color_name,"text-color":"white"}},[_vm._v("\n          "+_vm._s(row.item.priority)+"\n        ")])],1),_vm._v(" "),_c('td',[(row.item.process)?[_vm._v("\n            "+_vm._s(row.item.process.code)+"\n        ")]:[_vm._v("---")]],2),_vm._v(" "),_c('td',[(row.item.machine)?[_vm._v("\n            "+_vm._s(row.item.machine.name)+"\n        ")]:[_vm._v("---")]],2),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("format-date-time")(row.item.created)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("format-date-time")(row.item.modified)))])]}}])}),_vm._v(" "),_c('incident-modal',{attrs:{"drawer":_vm.drawer,"masters":_vm.masters}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 648:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(326);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33c286fa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(649);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33c286fa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 649:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-app',{attrs:{"id":"inspire"}},[_c('v-content',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md4":""}},[_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-card',{staticClass:"login-box-wrapper elevation-0"},[_c('v-card-text',[_c('v-flex',{staticClass:"logo-wrapper",attrs:{"xs12":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('img',{attrs:{"src":"/static/img/alumisel-120x32.png","alt":"Alumisel"}})])],1),_vm._v(" "),_c('v-text-field',{attrs:{"prepend-icon":"person","name":"login","label":"Login","type":"text","error-messages":_vm.fieldErrors.username},on:{"input":function($event){_vm.fieldErrors.username = []}},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.logIn($event)}},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}}),_vm._v(" "),_c('v-text-field',{attrs:{"prepend-icon":"lock","name":"password","label":"Password","id":"password","type":"password","error-messages":_vm.fieldErrors.password},on:{"input":function($event){_vm.fieldErrors.password = []}},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.logIn($event)}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"type":"submit","block":"","depressed":"","color":"primary","dark":""}},[_vm._v("Acceder")])],1)],1)],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 650:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Measurement_vue__ = __webpack_require__(327);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94dd463e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Measurement_vue__ = __webpack_require__(651);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Measurement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94dd463e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Measurement_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 651:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"elevation":"0"}},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-lg":"","fill-height":""}},[_c('v-form',{ref:"form",attrs:{"enctype":"multipart/form-data","novalidate":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"label":"Dispositivo","value":_vm.deviceName,"disabled":""}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"label":"Peso Total","disabled":""},model:{value:(_vm.measurement.weight),callback:function ($$v) {_vm.$set(_vm.measurement, "weight", $$v)},expression:"measurement.weight"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-select',{attrs:{"flat":"","items":_vm.materials,"label":"Materia Prima","item-value":"id","item-text":"name","disabled":""},model:{value:(_vm.materialId),callback:function ($$v) {_vm.materialId=$$v},expression:"materialId"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('date-picker',{attrs:{"date":_vm.startDate,"label":"Fecha comienzo","disabled":""},on:{"update:date":function($event){_vm.startDate=$event}}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('time-picker',{attrs:{"time":_vm.startTime,"label":"Hora comienzo","disabled":""},on:{"update:time":function($event){_vm.startTime=$event}}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('date-picker',{attrs:{"date":_vm.endDate,"label":"Fecha fin","disabled":""},on:{"update:date":function($event){_vm.endDate=$event}}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('time-picker',{attrs:{"time":_vm.endTime,"label":"Hora fin","disabled":""},on:{"update:time":function($event){_vm.endTime=$event}}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-textarea',{attrs:{"label":"Comentarios"},model:{value:(_vm.measurement.comment),callback:function ($$v) {_vm.$set(_vm.measurement, "comment", $$v)},expression:"measurement.comment"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',{staticClass:"pa-3"},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","large":"","depressed":"","disabled":!_vm.valid,"loading":_vm.loading},on:{"click":_vm.submit}},[_vm._v("\n        Guardar\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 652:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeasurementList_vue__ = __webpack_require__(328);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d25cf084_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeasurementList_vue__ = __webpack_require__(653);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeasurementList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d25cf084_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeasurementList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 653:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{staticClass:"pa-3",attrs:{"flat":""}},[_c('v-text-field',{attrs:{"label":"Buscar","append-icon":"search"},model:{value:(_vm.activeFilters.search),callback:function ($$v) {_vm.$set(_vm.activeFilters, "search", $$v)},expression:"activeFilters.search"}})],1),_vm._v(" "),_c('data-table',{attrs:{"total":_vm.totalResults,"items":_vm.measurements,"headers":_vm.headers,"loading":_vm.loading,"row-action":_vm.toDetailRoute,"page":_vm.currentPage},on:{"paginationUpdated":_vm.paginationUpdated},scopedSlots:_vm._u([{key:"row",fn:function(row){return [_c('td',[_vm._v(_vm._s(row.item.code))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("format-date-time")(row.item.start)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("format-date-time")(row.item.end)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.item.device.code))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.item.material.code))]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[(row.item.weight)?_c('span',[_vm._v(_vm._s(row.item.weight)+" "),_c('sub',[_vm._v("t")])]):_vm._e()]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[(row.item.speed)?_c('span',[_vm._v(_vm._s(row.item.speed)+" "),_c('sub',[_vm._v("t/hora")])]):_vm._e()])]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 654:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Error_vue__ = __webpack_require__(329);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f2d66f8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error_vue__ = __webpack_require__(655);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Error_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f2d66f8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 655:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-lg":"","fill-height":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_vm._v("\n    No ha sido posible cargar la información.\n    Por favor, inténtelo más tarde.\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 656:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Process_vue__ = __webpack_require__(330);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ffe2014_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Process_vue__ = __webpack_require__(663);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Process_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ffe2014_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Process_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 657:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"elevation":"0"}},[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"form",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"grid-list-xl":"","fluid":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-select',{attrs:{"items":_vm.masters.processTypes,"loading":_vm.loading,"label":"Tipo de proceso *","item-value":"id","item-text":"name","disabled":!_vm.processTypeAndMaterialEditable,"error-messages":_vm.errors.process_type,"required":""},on:{"change":function($event){_vm.errors.process_type = []},"input":_vm.processTypeChanged},model:{value:(_vm.process.process_type),callback:function ($$v) {_vm.$set(_vm.process, "process_type", $$v)},expression:"process.process_type"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-select',{attrs:{"items":_vm.materials,"loading":_vm.loading,"label":"Materia Prima *","item-value":"id","item-text":"name","disabled":!_vm.processTypeAndMaterialEditable || !_vm.process.process_type,"error-messages":_vm.errors.material,"required":""},on:{"change":function($event){_vm.errors.material = []}},model:{value:(_vm.process.material),callback:function ($$v) {_vm.$set(_vm.process, "material", $$v)},expression:"process.material"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"label":"Turno","suffix":"horas","type":"number","error-messages":_vm.errors.worker_schedule_hours},on:{"input":function($event){_vm.errors.worker_schedule_hours = []}},model:{value:(_vm.process.worker_schedule_hours),callback:function ($$v) {_vm.$set(_vm.process, "worker_schedule_hours", $$v)},expression:"process.worker_schedule_hours"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"label":"Descanso","suffix":"minutos","type":"number","error-messages":_vm.errors.break_time},on:{"input":function($event){_vm.errors.break_time = []}},model:{value:(_vm.process.break_time),callback:function ($$v) {_vm.$set(_vm.process, "break_time", $$v)},expression:"process.break_time"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('date-picker',{attrs:{"date":_vm.startDate,"label":"Fecha comienzo","error-messages":_vm.errors.start},on:{"update:date":function($event){_vm.startDate=$event},"change":function($event){_vm.errors.start = []}}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('time-picker',{attrs:{"time":_vm.startTime,"label":"Hora comienzo"},on:{"update:time":function($event){_vm.startTime=$event},"change":function($event){_vm.errors.start = []}}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('date-picker',{attrs:{"date":_vm.endDate,"label":"Fecha fin","error-messages":_vm.errors.end},on:{"update:date":function($event){_vm.endDate=$event},"change":function($event){_vm.errors.end = []}}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('time-picker',{attrs:{"time":_vm.endTime,"label":"Hora fin"},on:{"update:time":function($event){_vm.endTime=$event},"change":function($event){_vm.errors.end = []}}})],1),_vm._v(" "),(_vm.process.id)?_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"label":"Total paradas técnicas","suffix":"minutos","type":"number","disabled":""},model:{value:(_vm.process.minutes_lost_on_incidents),callback:function ($$v) {_vm.$set(_vm.process, "minutes_lost_on_incidents", $$v)},expression:"process.minutes_lost_on_incidents"}})],1):_vm._e(),_vm._v(" "),(_vm.process.id)?_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-select',{attrs:{"items":_vm.masters.statuses,"loading":_vm.loading,"cache-items":true,"label":"Estado","item-value":"id","item-text":"name","error-messages":_vm.fieldErrors.status,"required":""},on:{"change":function($event){_vm.fieldErrors.status = []}},model:{value:(_vm.process.status),callback:function ($$v) {_vm.$set(_vm.process, "status", $$v)},expression:"process.status"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":_vm.masters.tags,"loading":_vm.loading,"item-value":"id","item-text":"name","label":"Etiquetas *","multiple":"","chips":"","error-messages":_vm.errors.tags,"required":""},on:{"change":function($event){_vm.errors.tags = []}},model:{value:(_vm.process.tags),callback:function ($$v) {_vm.$set(_vm.process, "tags", $$v)},expression:"process.tags"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-textarea',{attrs:{"label":"Comentarios","error-messages":_vm.fieldErrors.comments},on:{"input":function($event){_vm.fieldErrors.comments = []}},model:{value:(_vm.process.comments),callback:function ($$v) {_vm.$set(_vm.process, "comments", $$v)},expression:"process.comments"}})],1)],1)],1),_vm._v(" "),_c('small',[_vm._v("*campos obligatorios")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',{staticClass:"pa-3"},[_c('v-spacer'),_vm._v(" "),(_vm.showCancel)?_c('v-btn',{attrs:{"flat":"","color":"accent"},on:{"click":function($event){_vm.$emit('cancel')}}},[_vm._v("Cancelar")]):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.valid,"large":"","depressed":"","color":"accent"},on:{"click":function($event){_vm.$emit('submit')}}},[_vm._v("\n        "+_vm._s(_vm.actionName)+"\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 658:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WeighingForm_vue__ = __webpack_require__(333);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_237b6b19_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WeighingForm_vue__ = __webpack_require__(659);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WeighingForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_237b6b19_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WeighingForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 659:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();}}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{class:{'warning--text': _vm.dirty },attrs:{"label":_vm.weighing.material.name,"suffix":_vm.getPercentage(_vm.weight),"type":"number","error-messages":_vm.fieldErrors.weight},on:{"keyup":_vm.debounceSubmit,"change":_vm.submit,"input":function($event){_vm.setDirty()}},model:{value:(_vm.weight),callback:function ($$v) {_vm.weight=$$v},expression:"weight"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 660:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnalysisForm_vue__ = __webpack_require__(334);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64f1b51e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnalysisForm_vue__ = __webpack_require__(662);
function injectStyle (ssrContext) {
  __webpack_require__(661)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnalysisForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64f1b51e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnalysisForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 661:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 662:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-list',_vm._l((_vm.list),function(analysis){return _c('v-list-group',{key:analysis.name,attrs:{"no-action":""}},[_c('v-list-tile',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-tile-title',[_vm._v("\n          "+_vm._s(analysis.name)+"\n        ")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("\n        Material:"),_c('strong',[_vm._v(" "+_vm._s(analysis.material))])]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("\n        Recalculation: "),_c('strong',[_vm._v(_vm._s(_vm._f("format-date-time")(analysis.recalculation)))])])],1),_vm._v(" "),_c('v-list-item',[_c('v-list-item-content',[[_c('table',{staticStyle:{"width":"100%"}},[_c('thead',[_c('tr',[_c('th',[_vm._v("Simbolo")]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v("Valor")])])]),_vm._v(" "),_c('tbody',_vm._l((analysis.analysis_elements),function(element){return _c('tr',{key:element.id},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(element.symbol))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(element.value))])])}))])]],2)],1)],1)}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 663:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-tabs',{attrs:{"slot":"extension","dark":"","color":"primary","align-with-title":""},slot:"extension",model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tabs-slider',{attrs:{"color":"primary"}}),_vm._v(" "),_c('v-tab',[_vm._v("Proceso")]),_vm._v(" "),_c('v-tab',[_vm._v("Pesadas")]),_vm._v(" "),_c('v-tab',[_vm._v("Incidencias")]),_vm._v(" "),(_vm.hasAnalysis)?_c('v-tab',[_vm._v("Analíticas")]):_vm._e()],1),_vm._v(" "),_c('v-tabs-items',{on:{"change":_vm.submit},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tab-item',[_c('process-form',{ref:"processForm",attrs:{"title":"","is-valid":_vm.valid,"process":_vm.process,"masters":_vm.masters,"errors":_vm.fieldErrors,"loading":_vm.loading,"action-name":"Guardar"},on:{"update:isValid":function($event){_vm.valid=$event},"update:process":function($event){_vm.process=$event},"update:masters":function($event){_vm.masters=$event},"submit":_vm.submit}})],1),_vm._v(" "),_c('v-tab-item',[_c('v-sheet',{staticClass:"pa-3"},_vm._l((_vm.process.weighings),function(weighing){return _c('weighing-form',{key:weighing.id,attrs:{"weighing":weighing},on:{"update:weighing":function($event){weighing=$event}}})}))],1),_vm._v(" "),_c('v-tab-item',[_c('data-table',{attrs:{"items":_vm.process.incidents,"headers":_vm.headers,"loading":_vm.loading,"row-action":_vm.toDetailRoute,"hide-actions":true},scopedSlots:_vm._u([{key:"row",fn:function(row){return [_c('td',[_vm._v(_vm._s(row.item.code))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.item.description))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.item.operator))]),_vm._v(" "),_c('td',[_vm._v("\n            "+_vm._s(row.item.duration)+"\n            "),(row.item.duration)?_c('span',[_vm._v(" m.")]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.item.severity_display))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.item.status_display))]),_vm._v(" "),_c('td',[_c('v-chip',{attrs:{"color":row.item.priority_color_name,"text-color":"white"}},[_vm._v("\n              "+_vm._s(row.item.priority)+"\n            ")])],1),_vm._v(" "),_c('td',[(row.item.machine)?[_vm._v("\n                "+_vm._s(row.item.machine.name)+"\n            ")]:[_vm._v("---")]],2),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("format-date-time")(row.item.created)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("format-date-time")(row.item.modified)))])]}}])}),_vm._v(" "),_c('incident-modal',{attrs:{"process":_vm.process,"masters":_vm.mastersIncidents}})],1),_vm._v(" "),(_vm.hasAnalysis)?_c('v-tab-item',[_c('v-sheet',{staticClass:"pa-3"},[_c('analysis-form',{attrs:{"analysisList":_vm.process.analysis},on:{"update:analysisList":function($event){_vm.$set(_vm.process, "analysis", $event)}}})],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 664:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProcessList_vue__ = __webpack_require__(335);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3098bc68_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProcessList_vue__ = __webpack_require__(665);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProcessList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3098bc68_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProcessList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 665:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-navigation-drawer',{staticClass:"filters-nav",attrs:{"absolute":"","temporary":"","disable-route-watcher":"","right":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-list',{staticClass:"filters"},[_c('v-subheader',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('label',[_vm._v("Filtros")])]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs6":""}},[(_vm.activeFiltersCount)?_c('a',{on:{"click":_vm.resetFilters}},[_vm._v("Borrar todo")]):_vm._e()])],1)],1),_vm._v(" "),_c('v-list-group',{staticClass:"active"},[_c('v-list-tile',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-tile-content',[_c('v-list-tile-title',{class:{'': _vm.isSomeFilterActive(['start__gte', 'end__lte'])}},[_vm._v("\n              Fecha comienzo/fin\n            ")]),_vm._v(" "),(_vm.isSomeFilterActive(['start__gte', 'end__lte']))?_c('v-list-tile-sub-title',[_vm._v("\n              "+_vm._s(_vm.activeFilters.start__gte)+" "),(_vm.activeFilters.start__gte && _vm.activeFilters.end__lte)?_c('label',[_vm._v("/")]):_vm._e(),_vm._v(" "+_vm._s(_vm.activeFilters.end__lte)+"\n            ")]):_vm._e()],1)],1),_vm._v(" "),_c('v-menu',{ref:"start__gte",attrs:{"close-on-content-click":false,"nudge-right":5,"full-width":"","offset-y":"","min-width":"290px"},model:{value:(_vm.start__gte),callback:function ($$v) {_vm.start__gte=$$v},expression:"start__gte"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Fecha comienzo","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.activeFilters.start__gte),callback:function ($$v) {_vm.$set(_vm.activeFilters, "start__gte", $$v)},expression:"activeFilters.start__gte"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"first-day-of-week":1,"locale":"es-es","no-title":"","scrollable":"","flat":""},on:{"input":function($event){_vm.start__gte = false}},model:{value:(_vm.activeFilters.start__gte),callback:function ($$v) {_vm.$set(_vm.activeFilters, "start__gte", $$v)},expression:"activeFilters.start__gte"}})],1),_vm._v(" "),_c('v-menu',{ref:"end__lte",attrs:{"close-on-content-click":false,"nudge-right":5,"full-width":"","offset-y":"","min-width":"290px"},model:{value:(_vm.end__lte),callback:function ($$v) {_vm.end__lte=$$v},expression:"end__lte"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Fecha fin","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.activeFilters.end__lte),callback:function ($$v) {_vm.$set(_vm.activeFilters, "end__lte", $$v)},expression:"activeFilters.end__lte"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"first-day-of-week":1,"locale":"es-es","no-title":"","scrollable":""},on:{"input":function($event){_vm.end__lte = false}},model:{value:(_vm.activeFilters.end__lte),callback:function ($$v) {_vm.$set(_vm.activeFilters, "end__lte", $$v)},expression:"activeFilters.end__lte"}})],1)],1),_vm._v(" "),_c('v-list-group',{staticClass:"active"},[_c('v-list-tile',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-tile-content',[_c('v-list-tile-title',{class:{'': _vm.isFilterActive('status')}},[_vm._v("\n              Estado\n            ")]),_vm._v(" "),(_vm.isFilterActive('status'))?_c('v-list-tile-sub-title',[_vm._v("\n              "+_vm._s(_vm.getSelectedStatus())+"\n            ")]):_vm._e()],1)],1),_vm._v(" "),_vm._l((_vm.masters.statuses),function(status){return _c('v-list-tile',{key:status.id},[_c('v-list-tile-action',{staticClass:"checkbox-list"},[_c('v-checkbox',{attrs:{"value":status.id},model:{value:(_vm.activeFilters.status),callback:function ($$v) {_vm.$set(_vm.activeFilters, "status", $$v)},expression:"activeFilters.status"}})],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v(_vm._s(status.name))])],1)})],2),_vm._v(" "),_c('v-list-group',{staticClass:"active"},[_c('v-list-tile',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-tile-content',[_c('v-list-tile-title',{class:{'': _vm.isFilterActive('process_type')}},[_vm._v("\n              Tipo de Proceso\n            ")]),_vm._v(" "),(_vm.isFilterActive('process_type'))?_c('v-list-tile-sub-title',[_vm._v("\n              "+_vm._s(_vm.selectedProcessType.name)+"\n            ")]):_vm._e()],1)],1),_vm._v(" "),_c('v-radio-group',{attrs:{"hide-details":true},on:{"change":_vm.loadProcessTypeMaterials},model:{value:(_vm.activeFilters.process_type),callback:function ($$v) {_vm.$set(_vm.activeFilters, "process_type", $$v)},expression:"activeFilters.process_type"}},_vm._l((_vm.masters.processTypes),function(processType){return _c('v-radio',{key:processType.id,attrs:{"label":processType.name,"value":processType.id}})}))],1),_vm._v(" "),_c('v-list-group',{staticClass:"active"},[_c('v-list-tile',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-tile-content',[_c('v-list-tile-title',{class:{'': _vm.isFilterActive('tags')}},[_vm._v("\n              Etiquetas\n            ")]),_vm._v(" "),(_vm.isFilterActive('tags'))?_c('v-list-tile-sub-title',[_vm._v("\n              "+_vm._s(_vm.selectedTags.name)+"\n            ")]):_vm._e()],1)],1),_vm._v(" "),_vm._l((_vm.masters.tags),function(tag){return _c('v-list-tile',{key:tag.id},[_c('v-list-tile-action',{staticClass:"checkbox-list"},[_c('v-checkbox',{attrs:{"value":tag.id},model:{value:(_vm.activeFilters.tags),callback:function ($$v) {_vm.$set(_vm.activeFilters, "tags", $$v)},expression:"activeFilters.tags"}})],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v(_vm._s(tag.name))])],1)})],2),_vm._v(" "),_c('v-list-group',{attrs:{"disabled":!_vm.isFilterActive('process_type')}},[_c('v-list-tile',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-tile-content',[_c('v-list-tile-title',{class:{'': _vm.isFilterActive('process_type')}},[_vm._v("\n              Materiales\n            ")]),_vm._v(" "),(_vm.isFilterActive('process_type'))?_c('v-list-tile-sub-title',[_vm._v("\n              "+_vm._s(_vm.getSelectedMaterials())+"\n            ")]):_vm._e()],1)],1),_vm._v(" "),_vm._l((_vm.masters.materials),function(material){return _c('v-list-tile',{key:material.id,attrs:{"dense":true}},[_c('v-list-tile-action',{staticClass:"checkbox-list"},[_c('v-checkbox',{attrs:{"value":material.id},model:{value:(_vm.activeFilters.material),callback:function ($$v) {_vm.$set(_vm.activeFilters, "material", $$v)},expression:"activeFilters.material"}})],1),_vm._v(" "),_c('v-list-tile-title',{staticClass:"caption"},[_vm._v(_vm._s(material.name))])],1)})],2),_vm._v(" "),_c('v-list-group',{staticClass:"active"},[_c('v-list-tile',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-tile-content',[_c('v-list-tile-title',{class:{'': _vm.isFilterActive('has_analysis')}},[_vm._v("\n              Analísis\n          ")])],1)],1),_vm._v(" "),_c('v-radio-group',{attrs:{"hide-details":true},on:{"change":_vm.loadProcessTypeMaterials},model:{value:(_vm.activeFilters.has_analysis),callback:function ($$v) {_vm.$set(_vm.activeFilters, "has_analysis", $$v)},expression:"activeFilters.has_analysis"}},[_c('v-radio',{key:1,attrs:{"label":"Sí","value":"true"}}),_vm._v(" "),_c('v-radio',{key:2,attrs:{"label":"No","value":"false"}})],1)],1)],1)],1),_vm._v(" "),_c('v-toolbar',{staticClass:"pa-3",attrs:{"flat":""}},[_c('v-text-field',{attrs:{"label":"Busca por código, observaciones, tipo, materia y etiquetas","append-icon":"search"},model:{value:(_vm.activeFilters.search),callback:function ($$v) {_vm.$set(_vm.activeFilters, "search", $$v)},expression:"activeFilters.search"}}),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"accent"},on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}},[_c('v-badge',{attrs:{"color":"primary","value":_vm.activeFiltersCount}},[_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v(_vm._s(_vm.activeFiltersCount))]),_vm._v(" "),_c('span',[_vm._v("Filtros")])])],1)],1),_vm._v(" "),_c('data-table',{attrs:{"pagination":_vm.pagination,"total":_vm.totalResults,"items":_vm.processes,"headers":_vm.headers,"loading":_vm.loading,"row-action":_vm.toDetailRoute,"page":_vm.currentPage},on:{"update:pagination":function($event){_vm.pagination=$event},"paginationUpdated":_vm.paginationUpdated},scopedSlots:_vm._u([{key:"row",fn:function(row){return [_c('td',[_vm._v(_vm._s(row.item.code))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.item.process_type.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.item.material.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.item.status_display))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("format-date-time")(row.item.start)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("format-date-time")(row.item.end)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(row.item.total_minutes_lost)+" m.")]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(row.item.total_weight)+" t.")]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(_vm.hasAnalysis(row.item.analysis))+" ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("format-date-time")(row.item.created)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("format-date-time")(row.item.modified)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.item.tags.toString()))])]}}])}),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"640px"},model:{value:(_vm.dialogs.newProcess),callback:function ($$v) {_vm.$set(_vm.dialogs, "newProcess", $$v)},expression:"dialogs.newProcess"}},[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(!_vm.drawer),expression:"!drawer"}],staticClass:"elevation-2",attrs:{"slot":"activator","color":"accent","top":"","right":"","fixed":"","fab":""},slot:"activator"},[_c('v-icon',[_vm._v("add")])],1),_vm._v(" "),_c('process-form',{attrs:{"title":"Nuevo proceso","is-valid":_vm.valid,"process":_vm.newProcess,"show-cancel":true,"errors":_vm.fieldErrors,"action-name":"crear","masters":_vm.masters},on:{"update:isValid":function($event){_vm.valid=$event},"update:process":function($event){_vm.newProcess=$event},"cancel":function($event){_vm.dialogs.newProcess = false},"submit":_vm.submit}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 666:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportList_vue__ = __webpack_require__(336);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_037306b6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportList_vue__ = __webpack_require__(673);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_037306b6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 667:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IncidentsReport_vue__ = __webpack_require__(337);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59871772_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IncidentsReport_vue__ = __webpack_require__(668);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IncidentsReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59871772_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IncidentsReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 668:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-card',{attrs:{"elevation":"0"}},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-xl":"","fluid":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('date-picker',{attrs:{"date":_vm.params.start,"error-messages":_vm.fieldErrors.start,"label":"Desde"},on:{"update:date":function($event){_vm.$set(_vm.params, "start", $event)},"change":function($event){_vm.fieldErrors.start = []}}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('date-picker',{attrs:{"date":_vm.params.end,"error-messages":_vm.fieldErrors.end,"label":"Hasta"},on:{"update:date":function($event){_vm.$set(_vm.params, "end", $event)},"change":function($event){_vm.fieldErrors.end = []}}})],1)],1)],1),_vm._v(" "),_c('small',[_vm._v("*campos obligatorios")])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',{staticClass:"pa-3"},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"depressed":"","large":"","color":"accent","type":"submit","loading":_vm.loading}},[_vm._v("\n          Generar informe\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 669:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductionReport_vue__ = __webpack_require__(338);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c03e23c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductionReport_vue__ = __webpack_require__(670);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductionReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c03e23c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductionReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 670:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-card',{attrs:{"elevation":"0"}},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-xl":"","fluid":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-select',{attrs:{"items":_vm.masters.processTypes,"loading":_vm.loading,"label":"Tipo de proceso","item-value":"id","item-text":"name","error-messages":_vm.fieldErrors.process_type,"required":""},on:{"change":function($event){_vm.fieldErrors.process_type = []},"input":_vm.processTypeChanged},model:{value:(_vm.params.process_type),callback:function ($$v) {_vm.$set(_vm.params, "process_type", $$v)},expression:"params.process_type"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-select',{attrs:{"items":_vm.masters.materials,"loading":_vm.loading,"label":"Materia Prima","item-value":"id","item-text":"name","disabled":!_vm.params.process_type,"error-messages":_vm.fieldErrors.material},on:{"change":function($event){_vm.fieldErrors.material = []}},model:{value:(_vm.params.material),callback:function ($$v) {_vm.$set(_vm.params, "material", $$v)},expression:"params.material"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('date-picker',{attrs:{"date":_vm.params.start,"error-messages":_vm.fieldErrors.start,"label":"Desde"},on:{"update:date":function($event){_vm.$set(_vm.params, "start", $event)},"change":function($event){_vm.fieldErrors.start = []}}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('date-picker',{attrs:{"date":_vm.params.end,"error-messages":_vm.fieldErrors.end,"label":"Hasta"},on:{"update:date":function($event){_vm.$set(_vm.params, "end", $event)},"change":function($event){_vm.fieldErrors.end = []}}})],1)],1)],1),_vm._v(" "),_c('small',[_vm._v("*campos obligatorios")])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',{staticClass:"pa-3"},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"large":"","depressed":"","color":"accent","type":"submit","loading":_vm.loading}},[_vm._v("\n          Generar informe\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 671:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeasurementsReport_vue__ = __webpack_require__(339);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f67ea86_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeasurementsReport_vue__ = __webpack_require__(672);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeasurementsReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f67ea86_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeasurementsReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 672:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-card',{attrs:{"elevation":"0"}},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-xl":"","fluid":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('date-picker',{attrs:{"date":_vm.params.start,"error-messages":_vm.fieldErrors.start,"label":"Desde"},on:{"update:date":function($event){_vm.$set(_vm.params, "start", $event)},"change":function($event){_vm.fieldErrors.start = []}}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('date-picker',{attrs:{"date":_vm.params.end,"error-messages":_vm.fieldErrors.end,"label":"Hasta"},on:{"update:date":function($event){_vm.$set(_vm.params, "end", $event)},"change":function($event){_vm.fieldErrors.end = []}}})],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',{staticClass:"pa-3"},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"large":"","depressed":"","color":"accent","type":"submit","loading":_vm.loading}},[_vm._v("\n          Generar informe\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 673:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-tabs',{attrs:{"slot":"extension","dark":"","color":"primary","align-with-title":""},slot:"extension",model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tabs-slider',{attrs:{"color":"white"}}),_vm._v(" "),_c('v-tab',[_vm._v("Producción")]),_vm._v(" "),_c('v-tab',[_vm._v("Incidencias")]),_vm._v(" "),_c('v-tab',[_vm._v("Pesadas")])],1),_vm._v(" "),_c('v-tabs-items',{model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tab-item',[_c('production-report')],1),_vm._v(" "),_c('v-tab-item',[_c('incidents-report')],1),_vm._v(" "),_c('v-tab-item',[_c('measurements-report')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 674:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(340);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12434da5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(678);
function injectStyle (ssrContext) {
  __webpack_require__(675)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12434da5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 675:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 676:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Snackbar_vue__ = __webpack_require__(341);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_373731ab_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Snackbar_vue__ = __webpack_require__(677);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Snackbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_373731ab_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Snackbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 677:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',{attrs:{"timeout":_vm.options.timeout,"color":_vm.options.backgroundColor,"multi-line":_vm.options.mode === 'multi-line',"vertical":_vm.options.mode === 'vertical',"top":_vm.options.position === 'top',"bottom":_vm.options.position === 'bottom',"right":_vm.options.position === 'right',"left":_vm.options.position === 'left'},model:{value:(_vm.options.visible),callback:function ($$v) {_vm.$set(_vm.options, "visible", $$v)},expression:"options.visible"}},[_vm._v("\n  "+_vm._s(_vm.options.message)+"\n  "),_c('v-btn',{attrs:{"flat":"","color":_vm.options.textColor},nativeOn:{"click":function($event){_vm.options.visible = false}}},[_vm._v("Cerrar")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 678:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("page " + _vm.currentRouteName + "-page"),attrs:{"id":"app"}},[_c('v-app',[(_vm.authenticated)?_c('v-navigation-drawer',{attrs:{"fixed":"","clipped":_vm.$vuetify.breakpoint.lgAndUp,"app":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-list',{staticClass:"pa-0 py-3"},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-avatar',[_c('v-icon',{staticClass:"grey lighten-2",attrs:{"color":"grey darken-2","large":""}},[_vm._v("person")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.profile.fullname))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.profileGroups))])],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',{staticClass:"pt-0",attrs:{"dense":""}},[_c('v-list-tile',{attrs:{"to":{name: 'home'}}},[_c('v-list-tile-action',{staticClass:"pl-2"},[_c('v-icon',[_vm._v("home")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Inicio")])],1)],1),_vm._v(" "),_vm._l((_vm.navigation),function(item){return _c('v-list-tile',{key:item.title,attrs:{"to":{ name: item.route}}},[_c('v-list-tile-action',{staticClass:"pl-2"},[_c('v-icon',[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.title))])],1)],1)}),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.logOut()}}},[_c('v-list-tile-action',{staticClass:"pl-2"},[_c('v-icon',[_vm._v("exit_to_app")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Salir")])],1)],1)],2)],1):_vm._e(),_vm._v(" "),(_vm.authenticated)?_c('v-toolbar',{staticClass:"elevation-3",attrs:{"color":"primary","dark":"","clipped-left":_vm.$vuetify.breakpoint.lgAndUp,"fixed":"","app":""}},[_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}}),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.pageTitle))]),_vm._v(" "),_c('v-spacer')],1):_vm._e(),_vm._v(" "),_c('v-content',[_c('router-view',{class:("page " + (_vm.$route.name) + "-page")})],1),_vm._v(" "),_c('snackbar')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 92:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataTable_vue__ = __webpack_require__(322);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a69ebda0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataTable_vue__ = __webpack_require__(645);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a69ebda0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},[342]);


// WEBPACK FOOTER //
// static/js/app.237342036dd7113a44b2.js